<template>
  <v-row>
    <!-- CARREGAMENTO GERAL -->
    <template v-if="carregando || carregando2">
      <v-fade-transition>
        <v-card height="90vh" class="loading-container" v-show="carregando || carregando2" elevation="0">
          <div class="fulfilling-square-spinner">
            <div class="spinner-inner"></div>
          </div>
        </v-card>
      </v-fade-transition>
    </template>
    <!-- VISÃO GERENTE -->
    <template v-else-if="usuario.idgrupo === 6">
      <!-- FILTROS -->
      <v-col cols="12" md="12">
        <v-card>
          <v-card-text>
            <v-form>
              <v-row class="mb-n4">
                <v-col class="px-3">
                  <InputDatePicker :disabled="carregando" v-model="busca.dtdia" label="Data"
                                   :outlined="true" :dense="true" />
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="px-2 px-sm-4 my-0 pt-0 flex-column flex-sm-row">
            <v-spacer/>
            <!-- Seção superior: Timer e Switch -->
            <div class="align-center justify-space-between w-100 d-none d-md-flex">
              <small v-if="autoRefresh && !carregando" class="text--secondary text-caption">
                Próxima atualização em: {{ tempoRefresh }} segundos
              </small>
              <v-spacer class="d-none d-sm-flex" />
              <v-switch
                  hide-details
                  :loading="carregando"
                  v-model="autoRefresh"
                  :label="$vuetify.breakpoint.xsOnly ? 'Auto' : 'Atualização automática'"
                  color="primary"
                  class="my-0 py-0 mx-1"
              />
            </div>
            <div class="d-flex flex-wrap justify-end w-100">
              <v-btn
                  :loading="carregando"
                  :small="$vuetify.breakpoint.smAndUp"
                  :x-small="$vuetify.breakpoint.xsOnly"
                  color="primary"
                  class="ma-1 flex-grow-1 flex-sm-grow-0"
                  elevation="0"
                  @click="dialogBonificacoes = true"
                  v-if="permissao('dashboard_ranking_botao_bonificacoes') && false"
              >
                Vendedores
                <v-icon :size="$vuetify.breakpoint.xsOnly ? 16 : 18" class="ml-1 ml-sm-2">
                  mdi-magnify
                </v-icon>
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- CAMPANHA DE VENDAS 2ª EDIÇÃO — mesmas abas da visão de diretoria (CampanhaVendaMargem.vue: por mês
           + Acumulado Geral), mas como v-card inline em vez de dialog, com tabela plana (sem agrupar por
           classificação, mesmo padrão do card "Educa Comercial Ivaiporã" logo abaixo), sem a aba "Resultado
           Sorteio", e restrito aos vendedores da FILIAL do gerente logado, sem nenhum valor em R$ (o próprio
           componente resolve a permissão e busca os dados; ver CampanhaVendaMargemGerente.vue) -->
      <v-col v-if="permissao('dashboard_ranking_campanha_venda_margem_gerente')" cols="12">
        <campanha-venda-margem-gerente />
      </v-col>

      <!-- RANKING CAMPANHA BONIFICAÇÃO E-BOOK -->
      <v-col v-if="permissao('dashboard_ranking_bonificacao_ebook')" cols="12">
        <v-card outlined style="background: linear-gradient(135deg, #0B5C73 0%, #074464 100%); border-radius: 12px;" dark>
          <v-card-title>
            <v-icon class="mr-3" color="white">mdi-book-open-page-variant</v-icon>
            <div>
              <div>Educa Comercial Ivaiporã</div>
              <div class="text-caption font-weight-regular" style="opacity: 0.85;">
                Campanha de bonificação E-book · {{ busca.dtdia.split('-').reverse().join('/') }}
              </div>
            </div>
            <v-spacer/>
            <v-img class="mr-1" max-width="220" src="../../assets/icons/logo_min.png" />
          </v-card-title>
          <v-divider class="white"/>
          <v-card-text class="black--text pa-3" v-if="!carregandoEbook">
            <v-simple-table light>
              <thead>
              <tr class="blue-grey lighten-2" style="height: 50px;">
                <th class="white--text text-subtitle-2" style="width: 52px;">RK</th>
                <th class="white--text text-subtitle-2">Vendedor</th>
                <th class="white--text text-center text-subtitle-2">Pontos</th>
                <th class="white--text text-subtitle-2">
                  <div class="d-flex align-center justify-center">
                    <v-tooltip v-if="permissao('dashboard_ranking_bonificacao_ebook_colunas')" color="blue-grey" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn class="mr-1" icon fab x-small v-bind="attrs"
                               @click="mostrarColunasEbook = !mostrarColunasEbook" v-on="on">
                          <v-icon color="white" size="14">
                            {{ mostrarColunasEbook ? 'mdi-eye-off' : 'mdi-eye' }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span class="white--text">
                        {{ mostrarColunasEbook ? "Ocultar qtde. e valor de e-books" : "Mostrar qtde. e valor de e-books" }}
                      </span>
                    </v-tooltip>
                    <span>Elegível à premiação</span>
                  </div>
                </th>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColunasEbook" class="white--text text-center text-subtitle-2">Qtde vendas c/ e-book</th>
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColunasEbook" class="white--text text-center text-subtitle-2">Qtde e-books</th>
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColunasEbook" class="white--text text-center text-subtitle-2">Valor e-books</th>
                </v-fade-transition>
              </tr>
              </thead>
              <tbody class="font-size-table" v-if="rankingEbook.lista.length">
              <tr v-for="item in rankingEbook.lista" :key="item.idvendedor" class="font-weight-bold">
                <td style="height: 23px !important; width: 52px;" class="text-center">{{ item.posicao }}º</td>
                <td style="height: 23px !important; width:200px; max-width: 200px !important;" class="text-truncate" :title="item.vendedor">
                  <v-tooltip v-if="item.flag_gerente === 'T'" color="blue-grey" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-icon v-bind="attrs" v-on="on" size="18" color="deep-orange darken-1" class="mr-1">mdi-account-tie</v-icon>
                    </template>
                    <span class="white--text">Gerente — não participa da campanha</span>
                  </v-tooltip>
                  {{ item.vendedor }}
                </td>
                <td style="height: 23px !important;" class="text-center">{{ item.total_pontos }}</td>
                <td style="height: 23px !important;" class="text-center">{{ premiacaoEbookDoItem(item) }}</td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColunasEbook" style="height: 23px !important;" class="text-center">{{ item.total_vendas }}</td>
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColunasEbook" style="height: 23px !important;" class="text-center">{{ item.total_qtd_ebook }}</td>
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColunasEbook" style="height: 23px !important;" class="text-center">{{ formatarMoeda(item.total_valor_ebook) }}</td>
                </v-fade-transition>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td colspan="7" class="text-center py-4">Nenhum vendedor pontuou ainda neste mês.</td>
              </tr>
              </tbody>
              <tfoot v-if="rankingEbook.lista.length">
              <tr class="blue-grey lighten-2 white--text font-weight-bold" style="height: 40px;">
                <td colspan="2" class="text-uppercase">Total</td>
                <td class="text-center">{{ totaisRankingEbook.totalPontos }}</td>
                <td class="text-center">{{ formatarMoeda(totaisRankingEbook.totalPremiacao) }}</td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColunasEbook" class="text-center">{{ totaisRankingEbook.totalVendas }}</td>
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColunasEbook" class="text-center">{{ totaisRankingEbook.totalQtdEbook }}</td>
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColunasEbook" class="text-center">{{ formatarMoeda(totaisRankingEbook.totalValorEbook) }}</td>
                </v-fade-transition>
              </tr>
              </tfoot>
            </v-simple-table>
          </v-card-text>
          <v-card-text v-else>
            <v-skeleton-loader class="mx-auto" width="100%" height="74" type="image, image"></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- BONIFICACOES -->
      <v-col cols="12">
        <v-card outlined style="background: linear-gradient(135deg, #082f49 0%, #0c4a6e 100%); border-radius: 12px;" dark>
          <v-card-title>
            <v-icon class="mr-3" color="white">mdi-trophy-variant</v-icon>
            {{ abaSelecionada === 0 ? 'Filial' : 'Vendedores' }} | {{ busca.dtdia.split('-').reverse().join('/') }}
            <v-spacer/>
            <v-img class="mr-1" max-width="220" src="../../assets/icons/logo_min.png" />
          </v-card-title>

          <!-- Barra de Navegação -->
          <v-tabs
              v-model="abaSelecionada"
              background-color="transparent"
              show-arrows
              height="38px"
              slider-color="white"
              slider-size="3"
              color="white"
              class="elevation-0"
              style="border-radius: 0;"
          >
            <v-tab
                key="filiais"
                value="filiais"
                class="font-weight-medium text-capitalize"
                style="min-width: 140px; letter-spacing: 0.5px;"
            >
              <v-icon left size="20" class="mr-2">mdi-office-building</v-icon>
              <span>Filial</span>
            </v-tab>

            <v-tab
                key="vendedores"
                value="vendedores"
                class="font-weight-medium text-capitalize"
                style="min-width: 140px; letter-spacing: 0.5px;"
            >
              <v-icon left size="20" class="mr-2">mdi-account-group</v-icon>
              <span>Vendedores</span>
            </v-tab>
          </v-tabs>

          <v-divider class="white"/>

          <v-card-text class="black--text pa-3" v-if="!carregando2">
            <!-- Conteúdo das Abas -->
            <v-tabs-items v-model="abaSelecionada" touchless>
              <!-- Aba Filiais -->
              <v-tab-item key="filiais">
                <v-simple-table>
                  <thead>
                  <tr class="blue-grey lighten-2" style="height: 50px;">
                    <th class="white--text text-subtitle-2 pr-0">
                      <div class="d-flex align-center justify-space-between">
                        <span>Empresa</span>
                        <v-tooltip color="blue-grey" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-2"
                                icon
                                fab
                                x-small
                                v-bind="attrs"
                                @click="mostrarColuna1 = !mostrarColuna1"
                                v-on="on"
                            >
                              <v-icon color="white" size="14">
                                {{ mostrarColuna1 ? 'mdi-eye-off' : 'mdi-eye' }}
                              </v-icon>
                            </v-btn>
                          </template>
                          <span class="white--text">
                          {{ mostrarColuna1 ? "Ocultar Valores (R$)" : "Mostrar Valores (R$)" }}
                        </span>
                        </v-tooltip>
                      </div>
                    </th>
                    <th class="white--text text-subtitle-2" v-if="dataCampanha(busca.dtdia)">Venda Campanha</th>
                    <th class="white--text text-subtitle-2" v-if="dataCampanha(busca.dtdia)">Bonificação Vendedores</th>
                    <th class="white--text text-subtitle-2" v-if="dataCampanha(busca.dtdia)">Bonificação Gerente</th>
                    <!-- Meta e Venda (valores em R$) -->
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna1" class="white--text text-center text-subtitle-2">Meta Mensal (R$)</th>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna1" class="white--text text-center text-subtitle-2">Venda Acumulada (R$)</th>
                    </v-fade-transition>

                    <!-- Margens -->
                    <th class="white--text text-center text-subtitle-2">Margem Acumulada</th>
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna1" class="white--text text-center text-subtitle-2">Margem Meta (%)</th>
                    </v-fade-transition>

                    <!-- Atingimento Acumulado -->
                    <th class="white--text text-center text-subtitle-2">% Atingimento Acumulado</th>
<!--                    <v-fade-transition hide-on-leave>-->
<!--                      <th v-show="mostrarColuna1" class="white&#45;&#45;text text-center text-subtitle-2">Venda Projetada (R$)</th>-->
<!--                    </v-fade-transition>-->

                    <!-- Bonificação -->
                    <!--                    <v-fade-transition hide-on-leave>-->
                    <!--                      <th v-show="mostrarColuna1" class="white--text text-center text-subtitle-2">Bonificação Projetada (R$)</th>-->
                    <!--                    </v-fade-transition>-->

                    <!--                    <th class="white--text text-center text-subtitle-2">% Probabilidade de Bonificação</th>-->
                  </tr>
                  </thead>

                  <tbody class="font-size-table" v-if="rankingBoni.lista">
                  <tr v-for="(item) in rankingBoni.lista" :key="item.idempresa" class="font-weight-bold">
                    <td style="height: 23px !important; width:200px; max-width: 200px !important;" class="text-truncate" :title="item.empresa">
                      {{ item.empresa }}
                    </td>
                    <td style="height: 23px !important; width:200px; max-width: 200px !important;" class="text-truncate" v-if="dataCampanha(busca.dtdia)">
                      {{ (rankingCampanha.listaFiliais.find(v => v.idempresa === item.idempresa)?.vendabonificacao || 0) | formataDinheiro  }}
                    </td>
                    <td style="height: 23px !important; width:200px; max-width: 200px !important;" class="text-truncate" v-if="dataCampanha(busca.dtdia)">
                      {{ (rankingCampanha.listaFiliais.find(v => v.idempresa === item.idempresa)?.comissao || 0) | formataDinheiro  }}
                    </td>
                    <td
                        style="height: 23px !important; width:200px; max-width: 200px !important;"
                        class="text-truncate"
                        v-if="dataCampanha(busca.dtdia)"
                    >
                      {{
                        (
                            (rankingCampanha.listaFiliais.find(v => v.idempresa === item.idempresa)?.vendabonificacao || 0)
                            * 0.005
                        ) | formataDinheiro
                      }}
                    </td>



                    <!-- Meta e Venda (valores em R$) -->
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna1" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ item.meta | formataDinheiro }}
                      </td>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna1" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ item.venda | formataDinheiro }}
                      </td>
                    </v-fade-transition>

                    <!-- Margens -->
                    <td
                        :style="mostrarColuna1 ? 'height: 23px !important;' : 'height: 23px !important; font-size: 1.3em !important;'"
                        :class="margemCorBoni(item.margem, item.margemmeta)"
                        class="text-center text-truncate"
                    >
                      <v-icon color="blue" class="mr-1" :size="mostrarColuna1 ? 18: 25" v-if="item.margem>=item.margemmeta">mdi-arrow-up-bold</v-icon>
                      <v-icon color="red" class="mr-1" :size="mostrarColuna1 ? 18: 25" v-else>mdi-arrow-down-bold</v-icon>
                      {{ formatarPercentual(item.margem) }}
                    </td>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna1"  style="height: 23px !important;" class="text-center">
                        {{ formatarPercentual(item.margemmeta) }}
                      </td>
                    </v-fade-transition>

                    <!-- Atingimento Acumulado -->
                    <td
                        :style="mostrarColuna1 ? 'height: 23px !important;' : 'height: 23px !important; font-size: 1.3em !important;'"
                        :class="projecaoCor(item.atingimentoac)"
                        class="text-center text-truncate"
                    >
                      <v-icon color="blue" class="mr-1" :size="mostrarColuna1 ? 18: 25" v-if="item.atingimentoac>=110">mdi-arrow-up-bold</v-icon>
                      <v-icon color="green" class="mr-1" :size="mostrarColuna1 ? 18: 25" v-else-if="item.atingimentoac>=100">mdi-arrow-up-bold</v-icon>
                      <v-icon color="orange" class="mr-1" :size="mostrarColuna1 ? 18: 25" v-else-if="item.atingimentoac>=90">mdi-minus-thick</v-icon>
                      <v-icon color="red" class="mr-1" :size="mostrarColuna1 ? 18: 25" v-else>mdi-arrow-down-bold</v-icon>
                      {{ formatarPercentual(item.atingimentoac) }}
                    </td>
<!--                    <v-fade-transition hide-on-leave>-->
<!--                      <td v-show="mostrarColuna1" style="height: 23px !important;" class="text-center text-no-wrap">-->
<!--                        {{ item.vendaprojecao | formataDinheiro }}-->
<!--                      </td>-->
<!--                    </v-fade-transition>-->

                    <!-- Bonificação -->
                    <!--                    <v-fade-transition hide-on-leave>-->
                    <!--                      <td-->
                    <!--                          v-show="mostrarColuna1"-->
                    <!--                          style="height: 23px !important;"-->
                    <!--                          :class="bonificacaoCor(item.bonificacao)"-->
                    <!--                          class="text-center text-no-wrap font-weight-bold"-->
                    <!--                      >-->
                    <!--                        {{ item.bonificacao | formataDinheiro }}-->
                    <!--                      </td>-->
                    <!--                    </v-fade-transition>-->

                    <!--                    <td :style="mostrarColuna1 ? 'height: 23px !important;' : 'height: 23px !important; font-size: 1.3em !important;'"-->
                    <!--                        v-if="item.perbonificacao"-->
                    <!--                        :class="perBonificacaoCor(item.perbonificacao)"-->
                    <!--                        class="text-truncate text-center"-->
                    <!--                    >-->
                    <!--                      <v-icon color="blue" class="mr-1" :size="mostrarColuna1 ? 18: 25" v-if="item.perbonificacao>=100">mdi-arrow-up-bold</v-icon>-->
                    <!--                      <v-icon color="orange" class="mr-1" :size="mostrarColuna1 ? 18: 25" v-else-if="item.perbonificacao>=90">mdi-minus-thick</v-icon>-->
                    <!--                      <v-icon color="red" class="mr-1" :size="mostrarColuna1 ? 18: 25" v-else>mdi-arrow-down-bold</v-icon>-->
                    <!--                      {{ item.perbonificacao }}%-->
                    <!--                    </td>-->
                  </tr>
                  </tbody>
                </v-simple-table>
              </v-tab-item>

              <!-- Aba Vendedores -->
              <v-tab-item key="vendedores">
                <v-simple-table>
                  <thead>
                  <tr class="blue-grey lighten-2" style="height: 50px;">
                    <th class="white--text text-subtitle-2">RK</th>
                    <th class="white--text text-subtitle-2 pr-0">
                      <div class="d-flex align-center justify-space-between">
                        <span>Vendedor</span>
                        <v-tooltip color="blue-grey" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-2"
                                icon
                                fab
                                x-small
                                v-bind="attrs"
                                @click="mostrarColuna1 = !mostrarColuna1"
                                v-on="on"
                            >
                              <v-icon color="white" size="14">
                                {{ mostrarColuna1 ? 'mdi-eye-off' : 'mdi-eye' }}
                              </v-icon>
                            </v-btn>
                          </template>
                          <span class="white--text">
                          {{ mostrarColuna1 ? "Ocultar Valores (R$)" : "Mostrar Valores (R$)" }}
                        </span>
                        </v-tooltip>
                      </div>
                    </th>

                    <th class="white--text text-subtitle-2">Filial</th>
                    <th class="white--text text-center text-subtitle-2" v-if="dataCampanha(busca.dtdia)">Venda Campanha</th>
                    <th class="white--text text-center text-subtitle-2" v-if="dataCampanha(busca.dtdia)">Bonificação Campanha</th>

                    <!-- Meta e Venda Diário (valores em R$) -->
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna1" class="white--text text-center text-subtitle-2">Meta Diária Fixa (R$)</th>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna1" class="white--text text-center text-subtitle-2">Venda diária (R$)</th>
                    </v-fade-transition>

                    <th class="white--text text-center text-subtitle-2">Margem Diária</th>

                    <!-- Atingimento Diário -->
                    <th class="white--text text-center text-subtitle-2">% Atingimento Diário</th>

                    <!-- Meta e Venda (valores em R$) -->
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna1" class="white--text text-center text-subtitle-2">Meta Mensal (R$)</th>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna1" class="white--text text-center text-subtitle-2">Venda Acumulada (R$)</th>
                    </v-fade-transition>

                    <!-- Margens -->
                    <th class="white--text text-center text-subtitle-2">Margem Acumulada</th>
                    <!--                    <v-fade-transition hide-on-leave>-->
                    <!--                      <th v-show="mostrarColuna1" class="white--text text-center text-subtitle-2">Margem Meta (%)</th>-->
                    <!--                    </v-fade-transition>-->

                    <!-- Atingimento Acumulado -->
                    <th class="white--text text-center text-subtitle-2">% Atingimento Acumulado</th>
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna1" class="white--text text-center text-subtitle-2">Venda Projetada (R$)</th>
                    </v-fade-transition>

                    <!-- Bonificação -->
                    <!--                    <v-fade-transition hide-on-leave>-->
                    <!--                      <th v-show="mostrarColuna1" class="white--text text-center text-subtitle-2">Bonificação Projetada (R$)</th>-->
                    <!--                    </v-fade-transition>-->

                    <!--                    <th class="white--text text-center text-subtitle-2">% Probabilidade de Bonificação</th>-->
                  </tr>
                  </thead>

                  <tbody class="font-size-table" v-if="rankingBoniAnalitico.lista">
                  <tr v-for="(vendedor, i) in listaFiltradaComMeta" :key="vendedor.id" class="font-weight-bold">
                    <td style="height: 23px !important;" class="text-center">
                      {{ i + 1 }}
                    </td>

                    <td style="height: 23px !important; width:100px; max-width: 200px !important;" class="text-truncate" :title="vendedor.nome">
                      {{ vendedor.vendedor }}
                    </td>

                    <td style="height: 23px !important; width:80px; max-width: 150px !important;" class="text-truncate" :title="vendedor.filial">
                      {{ vendedor.empresa }}
                    </td>

                    <td style="height: 23px !important; width:80px; max-width: 150px !important;" class="text-truncate" v-if="dataCampanha(busca.dtdia)">
                      {{ (rankingCampanha.listaVendedores.find(v => v.idempresa == vendedor.idempresa && v.idvendedor == vendedor.idVendedor)?.vendabonificacao || 0) | formataDinheiro}}
                    </td>
                    <td style="height: 23px !important; width:80px; max-width: 150px !important;" class="text-truncate" v-if="dataCampanha(busca.dtdia)">
                      {{ (rankingCampanha.listaVendedores.find(v => v.idempresa == vendedor.idempresa && v.idvendedor == vendedor.idVendedor)?.comissao || 0) | formataDinheiro }}
                    </td>


                    <!-- Meta e Venda diária (valores em R$) -->
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna1" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ vendedor.metadia_new | formataDinheiro }}
                      </td>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna1" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ vendedor.vendad | formataDinheiro }}
                      </td>
                    </v-fade-transition>

                    <!-- Margem diária -->
                    <td
                        style="height: 23px !important;"
                        :class="margemCorBoni(vendedor.margemad, 24)"
                        class="text-center text-truncate"
                    >
                      <v-icon color="blue" class="mr-1" size="18" v-if="vendedor.margemad>=24">mdi-arrow-up-bold</v-icon>
                      <v-icon color="red" class="mr-1" size="18" v-else>mdi-arrow-down-bold</v-icon>
                      {{ formatarPercentual(vendedor.margemad) }}
                    </td>

                    <!-- Atingimento diário -->
                    <td
                        style="height: 23px !important;"
                        :class="projecaoCor(vendedor.peratingimentoad_new)"
                        class="text-center text-truncate"
                    >
                      <v-icon color="blue" class="mr-1" size="18" v-if="vendedor.peratingimentoad_new>=110">mdi-arrow-up-bold</v-icon>
                      <v-icon color="green" class="mr-1" size="18" v-else-if="vendedor.peratingimentoad_new>=100">mdi-arrow-up-bold</v-icon>
                      <v-icon color="orange" class="mr-1" size="18" v-else-if="vendedor.peratingimentoad_new>=90">mdi-minus-thick</v-icon>
                      <v-icon color="red" class="mr-1" size="18" v-else>mdi-arrow-down-bold</v-icon>
                      {{ formatarPercentual(vendedor.peratingimentoad_new) }}
                    </td>

                    <!-- Meta e Venda (valores em R$) -->
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna1" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ vendedor.meta | formataDinheiro }}
                      </td>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna1" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ vendedor.venda | formataDinheiro }}
                      </td>
                    </v-fade-transition>

                    <!-- Margens -->
                    <td
                        style="height: 23px !important;"
                        :class="margemCorBoni(vendedor.margemac, 24)"
                        class="text-center text-truncate"
                    >
                      <v-icon color="blue" class="mr-1" size="18" v-if="vendedor.margemac>=24">mdi-arrow-up-bold</v-icon>
                      <v-icon color="red" class="mr-1" size="18" v-else>mdi-arrow-down-bold</v-icon>
                      {{ formatarPercentual(vendedor.margemac) }}
                    </td>
                    <!--                    <v-fade-transition hide-on-leave>-->
                    <!--                      <td v-show="mostrarColuna1"  style="height: 23px !important;" class="text-center text-truncate">-->
                    <!--                        24.00 %-->
                    <!--                      </td>-->
                    <!--                    </v-fade-transition>-->

                    <!-- Atingimento Acumulado -->
                    <td
                        style="height: 23px !important;"
                        :class="projecaoCor(vendedor.perprojecao)"
                        class="text-center text-truncate"
                    >
                      <v-icon color="blue" class="mr-1" size="18" v-if="vendedor.perprojecao>=110">mdi-arrow-up-bold</v-icon>
                      <v-icon color="green" class="mr-1" size="18" v-else-if="vendedor.perprojecao>=100">mdi-arrow-up-bold</v-icon>
                      <v-icon color="orange" class="mr-1" size="18" v-else-if="vendedor.perprojecao>=90">mdi-minus-thick</v-icon>
                      <v-icon color="red" class="mr-1" size="18" v-else>mdi-arrow-down-bold</v-icon>
                      {{ formatarPercentual(vendedor.perprojecao) }}
                    </td>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna1" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ vendedor.vendaprojecao | formataDinheiro }}
                      </td>
                    </v-fade-transition>

                    <!-- Bonificação -->
                    <!--                    <v-fade-transition hide-on-leave>-->
                    <!--                      <td-->
                    <!--                          v-show="mostrarColuna1"-->
                    <!--                          style="height: 23px !important;"-->
                    <!--                          :class="bonificacaoCor(vendedor.bonificacao)"-->
                    <!--                          class="text-center text-no-wrap font-weight-bold"-->
                    <!--                      >-->
                    <!--                        {{ vendedor.bonificacao | formataDinheiro }}-->
                    <!--                      </td>-->
                    <!--                    </v-fade-transition>-->

                    <!--                    <td style="height: 23px"-->
                    <!--                        :class="perBonificacaoCor(vendedor.perbonificacao)"-->
                    <!--                        class="text-truncate text-center"-->
                    <!--                    >-->
                    <!--                      <v-icon color="blue" class="mr-1" size="18" v-if="vendedor.perbonificacao>=100">mdi-arrow-up-bold</v-icon>-->
                    <!--                      <v-icon color="orange" class="mr-1" size="18" v-else-if="vendedor.perbonificacao>=90">mdi-minus-thick</v-icon>-->
                    <!--                      <v-icon color="red" class="mr-1" size="18" v-else>mdi-arrow-down-bold</v-icon>-->
                    <!--                      {{ vendedor.perbonificacao }}%-->
                    <!--                    </td>-->
                  </tr>
                  </tbody>

                  <tfoot v-if="rankingBoniAnalitico.totais">
                  <tr class="blue-grey lighten-2 white--text font-weight-bold" style="height: 23px !important;">
                    <td style="height: 30px !important;" class="text-center">-</td>
                    <td style="height: 30px !important;" class="text-uppercase text-right" colspan="2">TOTAL</td>
                    <td class="text-uppercase" v-if="dataCampanha(busca.dtdia)">{{ (rankingCampanha.totais[0]?.vendabonificacao || 0) | formataDinheiro }}</td>
                    <td class="text-uppercase" v-if="dataCampanha(busca.dtdia)">{{ (rankingCampanha.totais[0]?.comissao || 0) | formataDinheiro }}</td>

                    <!-- Meta e Venda diária totais -->
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna1" style="height: 30px !important;" class="text-center text-no-wrap"></td>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna1" style="height: 30px !important;" class="text-center text-no-wrap"></td>
                    </v-fade-transition>

                    <!-- Margem diária / Atingimento diário totais (sempre visíveis) -->
                    <td style="height: 30px !important;" class="text-center"></td>
                    <td style="height: 30px !important;" class="text-center"></td>

                    <!-- Meta e Venda totais -->
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna1" style="height: 30px !important;" class="text-center text-no-wrap">
                        {{ rankingBoniAnalitico.totais.meta | formataDinheiro }}
                      </td>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna1" style="height: 30px !important;" class="text-center text-no-wrap">
                        {{ rankingBoniAnalitico.totais.venda | formataDinheiro }}
                      </td>
                    </v-fade-transition>

                    <!-- Margens totais -->
                    <td style="height: 30px !important;" class="text-center">
                      {{ formatarPercentual(rankingBoniAnalitico.totais.margem) }}
                    </td>
                    <!--                    <v-fade-transition hide-on-leave>-->
                    <!--                      <td v-show="mostrarColuna1"  style="height: 30px !important;" class="text-center">-->
                    <!--                        - -->
                    <!--                      </td>-->
                    <!--                    </v-fade-transition>-->

                    <!-- Projeção total -->
                    <td style="height: 30px !important;" class="text-center">
                      {{ formatarPercentual(rankingBoniAnalitico.totais.atingimentoac) }}
                    </td>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna1" style="height: 30px !important;" class="text-center text-no-wrap">
                        {{ rankingBoniAnalitico.totais.vendaprojecao | formataDinheiro }}
                      </td>
                    </v-fade-transition>

                    <!-- Bonificação total -->
                    <!--                    <v-fade-transition hide-on-leave>-->
                    <!--                      <td v-show="mostrarColuna1" style="height: 30px !important;" class="text-center text-no-wrap">-->
                    <!--                        {{ rankingBoniAnalitico.totais.bonificacao | formataDinheiro }}-->
                    <!--                      </td>-->
                    <!--                    </v-fade-transition>-->

                    <!--                    <td style="height: 30px !important;" class="text-center">-->
                    <!--                      - -->
                    <!--                    </td>-->
                  </tr>
                  </tfoot>
                </v-simple-table>
              </v-tab-item>

            </v-tabs-items>
          </v-card-text>

          <v-card-text v-else>
            <v-skeleton-loader class="mx-auto" width="100%" height="74" type="image, image"></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- VENDAS -->
      <v-col cols="12">
        <!--        <v-card outlined style="background: linear-gradient(135deg, #e6a100 0%, #e67f00 100%); border-radius: 12px;" light>-->
        <v-card outlined style="background: linear-gradient(135deg, #082f49 0%, #0c4a6e 100%); border-radius: 12px;" light>
          <v-card-title class="white--text">
            <v-icon class="mr-3" color="white">mdi-chart-line</v-icon>
            Vendas - GESTOR | {{ busca.dtdia.split('-').reverse().join('/') }}
            <v-spacer/>
            <v-img class="mr-1" max-width="220" src="../../assets/icons/logo_min.png" />
          </v-card-title>
          <v-divider class="white"/>
          <v-card-text class="black--text pa-3" v-if="!carregando2">
            <v-simple-table dense style="border: 1px solid #023449">
              <thead>
              <tr class="blue-grey lighten-2" style="height: 50px;">
                <th class="white--text text-subtitle-2 pr-0" width="200px">
                  <div class="d-flex align-center justify-space-between">
                    <span>Filial</span>
                    <v-tooltip color="blue-grey" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            class="ml-2"
                            icon
                            fab
                            x-small
                            v-bind="attrs"
                            @click="mostrarColuna2 = !mostrarColuna2"
                            v-on="on"
                        >
                          <v-icon color="white" size="14">
                            {{ mostrarColuna2 ? 'mdi-eye-off' : 'mdi-eye' }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span class="white--text">
                          {{ mostrarColuna2 ? "Ocultar Valores (R$)" : "Mostrar Valores (R$)" }}
                        </span>
                    </v-tooltip>
                  </div>
                </th>

                <!--                <v-fade-transition hide-on-leave>-->
                <!--                  <th v-show="mostrarColuna2" class="white&#45;&#45;text text-center text-subtitle-2">-->
                <!--                    Meta Diária Acumulada (R$)</th>-->
                <!--                </v-fade-transition>-->
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColuna2" class="white--text text-center text-subtitle-2">
                    Meta Diária Fixa (R$)</th>
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColuna2" class="white--text text-center text-subtitle-2">
                    Realizado Diário (R$)</th>
                </v-fade-transition>

                <th class="white--text text-center text-subtitle-2">
                  <span class="mt-1">Realizado diário</span>
                </th>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColuna2" class="white--text text-center text-subtitle-2">
                    Realizado acumulado (R$)</th>
                </v-fade-transition>
                <th class="white--text text-center text-subtitle-2">Realizado acumulado</th>
                <th class="white--text text-center text-subtitle-2">Margem diária</th>
                <th class="white--text text-center text-subtitle-2">Margem acumulada</th>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">Venda Projetada</th>
                </v-fade-transition>
                <th class="white--text text-center text-subtitle-2">% Venda Projetada</th>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColuna2" class="white--text text-center text-subtitle-2">
                    % Var. A.A</th>
                </v-fade-transition>
              </tr>
              </thead>
              <tbody class="font-size-table">
              <tr v-for="(u, i) in dialogDados" :key="i" class="font-weight-bold">
                <td style="height: 23px !important;" class="text-truncate">{{ u.filial }}</td>
                <!--                <v-fade-transition hide-on-leave>-->
                <!--                  <td v-show="mostrarColuna2" style="height: 23px !important;" class="text-center" :class="realizadoCor(u.perrealiadodiarioac)">{{-->
                <!--                      u.metadiariaacumulada |-->
                <!--                          formataDinheiro }}</td>-->
                <!--                </v-fade-transition>-->
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna2" style="height: 23px !important;" class="text-center" :class="realizadoCor(u.perrealiadodiarioac)">{{
                      u.metadia_new |
                          formataDinheiro }}</td>
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna2" style="height: 23px !important;" class="text-center" :class="realizadoCor(u.perrealiadodiarioac)">{{
                      u.realizadodia |
                          formataDinheiro }}</td>
                </v-fade-transition>
                <td :style="mostrarColuna2 ? 'height: 23px !important;' : 'height: 23px !important; font-size: 1.3em !important;'"
                    :class="realizadoCor(u.perrealiadodiarioac)" class="text-center text-truncate">
                  {{ u.perrealiadodiarioac.toFixed(2) }} %
                </td>

                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna2" style="height: 23px !important;" :class="realizadoCor(u.perealizadoac)" class="text-center">
                    {{ u.realizadoacumuladoac | formataDinheiro }}</td>
                </v-fade-transition>
                <td :style="mostrarColuna2 ? 'height: 23px !important;' : 'height: 23px !important; font-size: 1.3em !important;'"
                    :class="realizadoCor(u.perealizado)" class="text-center">
                  {{ u.perealizadoac.toFixed(2) }} %
                </td>
                <td :style="mostrarColuna2 ? 'height: 23px !important;' : 'height: 23px !important; font-size: 1.3em !important;'"
                    :class="margemCor(u.margemdiaria)" class="text-center">
                  {{ u.margemdiaria.toFixed(2) }} %
                </td>
                <td :style="mostrarColuna2 ? 'height: 23px !important;' : 'height: 23px !important; font-size: 1.3em !important;'"
                    :class="margemCor(u.margemacumuladaac)" class="text-center">
                  {{ u.margemacumuladaac.toFixed(2) }} %
                </td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna" style="height: 23px !important;" class="text-center text-no-wrap">
                    {{ u.projecaoreal | formataDinheiro }}
                  </td>
                </v-fade-transition>
                <td style="height: 23px !important;" class="text-center text-no-wrap">
                  {{ u.projecaoatingida.toFixed(2) }}%
                </td>
                <!--                <v-fade-transition hide-on-leave>-->
                <!--                  <td v-show="mostrarColuna2" style="height: 23px !important;"-->
                <!--                      :class="variacaoCor(u.variacao)" class="text-center text-truncate">-->
                <!--                    {{ u.variacao.toFixed(2) }} %-->
                <!--                  </td>-->
                <!--                </v-fade-transition>-->
                <v-fade-transition>
                  <td style="height: 23px !important;" v-show="mostrarColuna2" :class="variacaoCor(u.variacaoprojecaoaa || 0)"
                      class="text-center text-truncate">{{ formatarVariacao(u.variacaoprojecaoaa || 0) }}</td>
                </v-fade-transition>
              </tr>
              </tbody>
            </v-simple-table>
          </v-card-text>
          <v-card-text v-else>
            <v-skeleton-loader class="mx-auto" width="100%" height="74" type="image, image"></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- FATURAMENTO -->
      <v-col cols="12">
        <!--        <v-card outlined style="background: linear-gradient(135deg, #c81111 0%, #951015 100%); border-radius: 12px;" light>-->
        <v-card outlined style="background: linear-gradient(135deg, #082f49 0%, #0c4a6e 100%); border-radius: 12px;" light>
          <v-card-title class="white--text">
            <v-icon class="mr-3" color="white">mdi-finance</v-icon>
            <span>Faturamento DRE - GESTOR | {{ busca.dtdia.split('-').reverse().join('/') }}</span>
            <v-spacer/>
            <v-img class="mr-1" max-width="220" src="../../assets/icons/logo_min.png" />
          </v-card-title>
          <v-divider class="white"/>
          <v-card-text class="black--text pa-3" v-if="!carregando2">
            <v-simple-table dense style="border: 1px solid #023449">
              <thead>
              <tr class="blue-grey lighten-2" style="height: 50px;" >
                <th class="white--text text-subtitle-2 pr-0" width="200px">
                  <div class="d-flex align-center justify-space-between">
                    <span>Filial</span>
                    <v-tooltip color="blue-grey" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-btn
                            class="ml-2"
                            icon
                            fab
                            x-small
                            v-bind="attrs"
                            @click="mostrarColuna3 = !mostrarColuna3"
                            v-on="on"
                        >
                          <v-icon color="white" size="14">
                            {{ mostrarColuna3 ? 'mdi-eye-off' : 'mdi-eye' }}
                          </v-icon>
                        </v-btn>
                      </template>
                      <span class="white--text">
                          {{ mostrarColuna3 ? "Ocultar Valores (R$)" : "Mostrar Valores (R$)" }}
                        </span>
                    </v-tooltip>
                  </div>
                </th>
                <th class="white--text text-center text-subtitle-2">
                  <span class="mt-1">Realizado diário</span>
                </th>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColuna3" class="white--text text-center text-subtitle-2">
                    Realizado Diário (R$)</th>
                </v-fade-transition>
                <th class="white--text text-center text-subtitle-2">Realizado acumulado</th>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColuna3" class="white--text text-center text-subtitle-2">
                    Realizado Acumulado (R$)</th>
                </v-fade-transition>
                <th class="white--text text-center text-subtitle-2">Margem diária</th>
                <th class="white--text text-center text-subtitle-2">Margem acumulada</th>
                <th class="white--text text-center text-subtitle-2">Variação A.A %</th>
              </tr>
              </thead>
              <tbody class="font-size-table">
              <tr v-for="(u, i) in rankingFat.Fatdre" :key="i" class="font-weight-bold">
                <td style="height: 23px !important;" class="text-truncate pr-0">{{ u.empresa }}</td>
                <td :style="mostrarColuna3 ? 'height: 23px !important;' : 'height: 23px !important; font-size: 1.3em !important;'"
                    :class="realizadoCor(u.realizadodiarioperc)" class="text-center">
                  {{ u.realizadodiarioperc ? u.realizadodiarioperc.toFixed(2) : '-' }} %
                </td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna3" style="height: 23px !important;" :class="realizadoCor(u.realizadodiarioperc)" class="text-center">
                    {{ u.vendadiaria | formataDinheiro }}</td>
                </v-fade-transition>
                <td :style="mostrarColuna3 ? 'height: 23px !important;' : 'height: 23px !important; font-size: 1.3em !important;'"
                    :class="realizadoCor(u.realizadoacumuladoperc)" class="text-center">
                  {{ u.realizadoacumuladoperc ? u.realizadoacumuladoperc.toFixed(2) : '-' }} %
                </td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna3" style="height: 23px !important;" :class="realizadoCor(u.realizadoacumuladoperc)" class="text-center">
                    {{ u.vendaacumulada | formataDinheiro }}</td>
                </v-fade-transition>
                <td :style="mostrarColuna3 ? 'height: 23px !important;' : 'height: 23px !important; font-size: 1.3em !important;'"
                    :class="margemCor(u.margemdiaria)" class="text-center">
                  {{ u.margemdiaria ? u.margemdiaria.toFixed(2) : '-' }} %
                </td>
                <td :style="mostrarColuna3 ? 'height: 23px !important;' : 'height: 23px !important; font-size: 1.3em !important;'"
                    :class="margemCor(u.margemacumulada)" class="text-center">
                  {{ u.margemacumulada ? u.margemacumulada.toFixed(2) : '-' }} %
                </td>
                <!--                <td style="height: 23px !important;" :class="variacaoCor(u.variacaoaa)" class="text-center">-->
                <!--                  {{ u.variacaoaa ? u.variacaoaa.toFixed(2) : '-' }} %-->
                <!--                </td>-->
                <td style="height: 23px !important;" :class="variacaoCor(u.variacaoprojaa)" class="text-center">
                  {{ u.variacaoprojaa ? u.variacaoprojaa.toFixed(2) : '-' }} %
                </td>
              </tr>
              </tbody>
            </v-simple-table>
            <span class="text-caption white--text" style="display: block; text-align: end;">Data Processamento -  {{ rankingFat.dataprocessamento }}</span>
          </v-card-text>
          <v-card-text v-else>
            <v-skeleton-loader class="mx-auto" width="100%" height="74" type="image, image"></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
    </template>
    <template v-else>
      <!-- VISÃO DIRETORIA -->
      <v-dialog v-model="dialogBonificacoes" :max-width="mostrarColuna ? '1480' : '1080'" scrollable>
        <v-card>
          <v-card-title class="primary white--text">
            Ranking - {{ abaSelecionada === 0 ? 'FILIAIS' : 'VENDEDORES' }} | {{ busca.dtdia.split('-').reverse().join('/') }}
            <v-spacer />
            <v-img class="d-none d-md-flex" max-width="220" src="../../assets/icons/logo_min.png" />
          </v-card-title>

          <!-- Barra de Navegação -->
          <v-tabs
              v-model="abaSelecionada"
              background-color="transparent"
              show-arrows
              height="56px"
              slider-color="primary"
              slider-size="3"
              color="primary"
              class="elevation-1"
              style="border-radius: 0;"
          >
            <v-tab
                key="filiais"
                value="filiais"
                class="font-weight-medium text-capitalize"
                style="min-width: 140px; letter-spacing: 0.5px;"
            >
              <v-icon left size="20" class="mr-2">mdi-office-building</v-icon>
              <span>Filiais</span>
            </v-tab>

            <v-tab
                key="vendedores"
                value="vendedores"
                class="font-weight-medium text-capitalize"
                style="min-width: 140px; letter-spacing: 0.5px;"
            >
              <v-icon left size="20" class="mr-2">mdi-account-group</v-icon>
              <span>Vendedores</span>
            </v-tab>

            <v-spacer />

            <!-- Filtro compacto -->
            <v-fade-transition v-if="permissao('dashboard_ranking_filtro_filiais_bonificacoes')">
              <v-autocomplete
                  v-show="abaSelecionada === 1"
                  v-model="filtroFilial"
                  :items="filiaisFiltro"
                  item-text="filial"
                  item-value="idfilial"
                  placeholder="Filtrar filial..."
                  prepend-inner-icon="mdi-filter-outline"
                  clearable
                  dense
                  filled
                  hide-details
                  style="max-width: 220px; margin-top: 8px; margin-right: 16px;"
                  @change="listaVendedoresBonificacoes()"
              />
            </v-fade-transition>
          </v-tabs>

          <v-divider />
          <v-card-text v-if="carregando2">
            <v-skeleton-loader class="mx-auto" width="100%" height="300" type="image, image"></v-skeleton-loader>
          </v-card-text>
          <v-card-text v-else class="black--text pt-5 mb-n3">
            <!-- Conteúdo das Abas -->
            <v-tabs-items v-model="abaSelecionada">

              <!-- Aba Filiais -->
              <v-tab-item key="filiais" >
                <v-simple-table dense style="border: 1px solid #023449">
                  <thead>
                  <tr class="primary" style="height: 50px;">
                    <th class="white--text text-subtitle-2">RK</th>
                    <th class="white--text text-subtitle-2 pr-0">
                      <div class="d-flex align-center justify-space-between">
                        <span>Empresa</span>
                        <v-tooltip color="blue-grey" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-2"
                                icon
                                fab
                                x-small
                                v-bind="attrs"
                                @click="mostrarColuna = !mostrarColuna"
                                v-on="on"
                            >
                              <v-icon color="white" size="14">
                                {{ mostrarColuna ? 'mdi-eye-off' : 'mdi-eye' }}
                              </v-icon>
                            </v-btn>
                          </template>
                          <span class="white--text">
                          {{ mostrarColuna ? "Ocultar Valores (R$)" : "Mostrar Valores (R$)" }}
                        </span>
                        </v-tooltip>
                      </div>
                    </th>

                    <!-- Meta e Venda (valores em R$) -->
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">Meta Mensal (R$)</th>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">Venda Acumulada (R$)</th>
                    </v-fade-transition>
                    <th class="white--text text-left text-subtitle-2" v-if="dataCampanha(busca.dtdia)">Venda Campanha Pix</th>
                    <th class="white--text text-left text-subtitle-2" v-if="dataCampanha(busca.dtdia)">Bonificação Loja Campanha</th>
                    <th class="white--text text-left text-subtitle-2" v-if="dataCampanha(busca.dtdia)">Bonificação Gerente Campanha</th>
                    <!-- Margens -->
                    <th class="white--text text-center text-subtitle-2">Margem Acumulada</th>
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">Margem Meta (%)</th>
                    </v-fade-transition>

                    <!-- Atingimento Acumulado -->
                    <th class="white--text text-center text-subtitle-2">% Atingimento Acumulado</th>
<!--                    <v-fade-transition hide-on-leave>-->
<!--                      <th v-show="mostrarColuna" class="white&#45;&#45;text text-center text-subtitle-2">Venda Projetada (R$)</th>-->
<!--                    </v-fade-transition>-->

                    <!-- Bonificação -->
                    <!--                  <v-fade-transition hide-on-leave>-->
                    <!--                    <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">Bonificação Projetada (R$)</th>-->
                    <!--                  </v-fade-transition>-->

                    <!--                  <th class="white--text text-center text-subtitle-2">% Probabilidade de Bonificação</th>-->
                  </tr>
                  </thead>

                  <tbody v-if="rankingBoni.lista">
                  <tr v-for="(item, i) in rankingBoni.lista" :key="item.idempresa" class="font-weight-bold">
                    <td style="height: 23px !important;" class="text-center">
                      {{ i + 1 }}
                    </td>

                    <td style="height: 23px !important; width:100px; max-width: 200px !important;" class="text-truncate" :title="item.empresa">
                      {{ item.empresa }}
                    </td>

                    <!-- Meta e Venda (valores em R$) -->
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ item.meta | formataDinheiro }}
                      </td>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ item.venda | formataDinheiro }}
                      </td>
                    </v-fade-transition>
                    <td style="height: 23px !important;" class="text-left text-no-wrap" v-if="dataCampanha(busca.dtdia)">
                      {{ (rankingCampanha.listaFiliais.find(v => v.idempresa === item.idempresa)?.vendabonificacao || 0) | formataDinheiro  }}
                    </td>
                    <td style="height: 23px !important;" class="text-left text-no-wrap" v-if="dataCampanha(busca.dtdia)">
                      {{ (rankingCampanha.listaFiliais.find(v => v.idempresa === item.idempresa)?.comissao || 0) | formataDinheiro  }}
                    </td>
                    <td
                        style="height: 23px !important;"
                        class="text-left text-no-wrap"
                        v-if="dataCampanha(busca.dtdia)"
                    >
                      {{
                        (
                            (rankingCampanha.listaFiliais.find(v => v.idempresa === item.idempresa)?.vendabonificacao || 0)
                            * 0.005
                        ) | formataDinheiro
                      }}
                    </td>

                    <!-- Margens -->
                    <td
                        style="height: 23px !important;"
                        :class="margemCorBoni(item.margem, item.margemmeta)"
                        class="text-center text-truncate"
                    >
                      <v-icon color="blue" class="mr-1" size="18" v-if="item.margem>=item.margemmeta">mdi-arrow-up-bold</v-icon>
                      <v-icon color="red" class="mr-1" size="18" v-else>mdi-arrow-down-bold</v-icon>
                      {{ formatarPercentual(item.margem) }}
                    </td>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna"  style="height: 23px !important;" class="text-center">
                        {{ formatarPercentual(item.margemmeta) }}
                      </td>
                    </v-fade-transition>

                    <!-- Atingimento Acumulado -->
                    <td
                        style="height: 23px !important;"
                        :class="projecaoCor(item.atingimentoac)"
                        class="text-center text-truncate"
                    >
                      <v-icon color="blue" class="mr-1" size="18" v-if="item.atingimentoac>=110">mdi-arrow-up-bold</v-icon>
                      <v-icon color="green" class="mr-1" size="18" v-else-if="item.atingimentoac>=100">mdi-arrow-up-bold</v-icon>
                      <v-icon color="orange" class="mr-1" size="18" v-else-if="item.atingimentoac>=90">mdi-minus-thick</v-icon>
                      <v-icon color="red" class="mr-1" size="18" v-else>mdi-arrow-down-bold</v-icon>
                      {{ formatarPercentual(item.atingimentoac) }}
                    </td>
<!--                    <v-fade-transition hide-on-leave>-->
<!--                      <td v-show="mostrarColuna" style="height: 23px !important;" class="text-center text-no-wrap">-->
<!--                        {{ item.vendaprojecao | formataDinheiro }}-->
<!--                      </td>-->
<!--                    </v-fade-transition>-->

                    <!-- Bonificação -->
                    <!--                  <v-fade-transition hide-on-leave>-->
                    <!--                    <td-->
                    <!--                        v-show="mostrarColuna"-->
                    <!--                        style="height: 23px !important;"-->
                    <!--                        :class="bonificacaoCor(item.bonificacao)"-->
                    <!--                        class="text-center text-no-wrap font-weight-bold"-->
                    <!--                    >-->
                    <!--                      {{ item.bonificacao | formataDinheiro }}-->
                    <!--                    </td>-->
                    <!--                  </v-fade-transition>-->

                    <!--                  <td style="height: 23px"-->
                    <!--                      v-if="item.perbonificacao"-->
                    <!--                      :class="perBonificacaoCor(item.perbonificacao)"-->
                    <!--                      class="text-truncate text-center"-->
                    <!--                  >-->
                    <!--                    <v-icon color="blue" class="mr-1" size="18" v-if="item.perbonificacao>=100">mdi-arrow-up-bold</v-icon>-->
                    <!--                    <v-icon color="orange" class="mr-1" size="18" v-else-if="item.perbonificacao>=90">mdi-minus-thick</v-icon>-->
                    <!--                    <v-icon color="red" class="mr-1" size="18" v-else>mdi-arrow-down-bold</v-icon>-->
                    <!--                    {{ item.perbonificacao }}%-->
                    <!--                  </td>-->
                  </tr>
                  </tbody>

                  <!-- Footer com totais Filiais -->
                  <tfoot v-if="rankingBoni.totais">
                  <tr class="primary white--text font-weight-bold">
                    <td class="text-center">-</td>
                    <td class="text-uppercase">TOTAL</td>

                    <!-- Meta e Venda totais -->
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna" class="text-center text-no-wrap">
                        {{ rankingBoni.totais.meta | formataDinheiro }}
                      </td>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna" class="text-center text-no-wrap">
                        {{ rankingBoni.totais.venda | formataDinheiro }}
                      </td>
                    </v-fade-transition>

                    <td class="text-left" v-if="dataCampanha(busca.dtdia)">
                      {{ rankingCampanha.totais[0]?.vendabonificacao | formataDinheiro }}
                    </td>
                    <td class="text-left" v-if="dataCampanha(busca.dtdia)">
                      {{ rankingCampanha.totais[0]?.comissao | formataDinheiro }}
                    </td>
                    <td class="text-left" v-if="dataCampanha(busca.dtdia)">
                      {{
                        ((rankingCampanha.totais[0]?.vendabonificacao || 0) * 0.005)
                            | formataDinheiro
                      }}
                    </td>

                    <!-- Margens totais -->
                    <td class="text-center">
                      {{ formatarPercentual(rankingBoni.totais.margem) }}
                    </td>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna"  class="text-center">
                        -
                      </td>
                    </v-fade-transition>

                    <!-- Projeção total -->
                    <td class="text-center">
                      {{ formatarPercentual(rankingBoni.totais.atingimentoac)  }}
                    </td>
<!--                    <v-fade-transition hide-on-leave>-->
<!--                      <td v-show="mostrarColuna" class="text-center text-no-wrap">-->
<!--                        {{ rankingBoni.totais.vendaprojecao | formataDinheiro }}-->
<!--                      </td>-->
<!--                    </v-fade-transition>-->

                    <!-- Bonificação total -->
                    <!--                  <v-fade-transition hide-on-leave>-->
                    <!--                    <td v-show="mostrarColuna" class="text-center text-no-wrap">-->
                    <!--                      {{ rankingBoni.totais.bonificacao | formataDinheiro }}-->
                    <!--                    </td>-->
                    <!--                  </v-fade-transition>-->

                    <!--                  <td class="text-center">-->
                    <!--                    - -->
                    <!--                  </td>-->
                  </tr>
                  </tfoot>
                </v-simple-table>
              </v-tab-item>

              <!-- Aba Vendedores -->
              <v-tab-item key="vendedores" >
                <v-simple-table dense style="border: 1px solid #023449">
                  <thead>
                  <tr class="primary" style="height: 50px;">
                    <th class="white--text text-subtitle-2">RK</th>
                    <th class="white--text text-subtitle-2 pr-0">
                      <div class="d-flex align-center justify-space-between">
                        <span>Vendedor</span>
                        <v-tooltip color="blue-grey" bottom>
                          <template v-slot:activator="{ on, attrs }">
                            <v-btn
                                class="ml-2"
                                icon
                                fab
                                x-small
                                v-bind="attrs"
                                @click="mostrarColuna = !mostrarColuna"
                                v-on="on"
                            >
                              <v-icon color="white" size="14">
                                {{ mostrarColuna ? 'mdi-eye-off' : 'mdi-eye' }}
                              </v-icon>
                            </v-btn>
                          </template>
                          <span class="white--text">
                          {{ mostrarColuna ? "Ocultar Valores (R$)" : "Mostrar Valores (R$)" }}
                        </span>
                        </v-tooltip>
                      </div>
                    </th>

                    <th class="white--text text-subtitle-2">Filial</th>
                    <th class="white--text text-subtitle-2" v-if="dataCampanha(busca.dtdia)">Venda Campanha</th>
                    <th class="white--text text-subtitle-2" v-if="dataCampanha(busca.dtdia)">Bonificação Campanha</th>

                    <!-- Meta e Venda Diário (valores em R$) -->
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">Meta Diária Fixa (R$)</th>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">Venda diária (R$)</th>
                    </v-fade-transition>

                    <th class="white--text text-center text-subtitle-2">Margem Diária</th>

                    <!-- Atingimento Diário -->
                    <th class="white--text text-center text-subtitle-2">% Atingimento Diário</th>

                    <!-- Meta e Venda (valores em R$) -->
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">Meta Mensal (R$)</th>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">Venda Acumulada (R$)</th>
                    </v-fade-transition>

                    <!-- Margens -->
                    <th class="white--text text-center text-subtitle-2">Margem Acumulada</th>
                    <!--                  <v-fade-transition hide-on-leave>-->
                    <!--                    <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">Margem Meta (%)</th>-->
                    <!--                  </v-fade-transition>-->

                    <!-- Atingimento Acumulado -->
                    <th class="white--text text-center text-subtitle-2">% Atingimento Acumulado</th>
                    <v-fade-transition hide-on-leave>
                      <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">Venda Projetada (R$)</th>
                    </v-fade-transition>

                    <!-- Bonificação -->
                    <!--                  <v-fade-transition hide-on-leave>-->
                    <!--                    <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">Bonificação Projetada (R$)</th>-->
                    <!--                  </v-fade-transition>-->

                    <!--                  <th class="white--text text-center text-subtitle-2">% Probabilidade de Bonificação</th>-->
                  </tr>
                  </thead>

                  <tbody v-if="rankingBoniAnalitico.lista && !carregando2">
                  <tr
                      v-for="(vendedor, i) in listaFiltradaComMeta"
                      :key="vendedor.id"
                      class="font-weight-bold"
                  >
                    <td style="height: 23px !important;" class="text-center">
                      {{ i + 1 }}
                    </td>

                    <td style="height: 23px !important; width:100px; max-width: 200px !important;" class="text-truncate" :title="vendedor.nome">
                      {{ vendedor.vendedor }}
                    </td>

                    <td style="height: 23px !important; width:80px; max-width: 150px !important;" class="text-truncate" :title="vendedor.filial">
                      {{ vendedor.empresa }}
                    </td>
                    <td style="height: 23px !important; width:80px; max-width: 150px !important;" class="text-truncate" v-if="dataCampanha(busca.dtdia)">
                      {{ (rankingCampanha.listaVendedores.find(v => v.idempresa == vendedor.idempresa && v.idvendedor == vendedor.idVendedor)?.vendabonificacao || 0) | formataDinheiro}}
                    </td>
                    <td style="height: 23px !important; width:80px; max-width: 150px !important;" class="text-truncate" v-if="dataCampanha(busca.dtdia)">
                      {{ (rankingCampanha.listaVendedores.find(v => v.idempresa == vendedor.idempresa && v.idvendedor == vendedor.idVendedor)?.comissao || 0) | formataDinheiro }}
                    </td>

                    <!-- Meta e Venda diária (valores em R$) -->
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ vendedor.metadia_new | formataDinheiro }}
                      </td>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ vendedor.vendad | formataDinheiro }}
                      </td>
                    </v-fade-transition>

                    <!-- Margem diária -->
                    <td
                        style="height: 23px !important;"
                        :class="margemCorBoni(vendedor.margemad, 24)"
                        class="text-center text-truncate"
                    >
                      <v-icon color="blue" class="mr-1" size="18" v-if="vendedor.margemad>=24">mdi-arrow-up-bold</v-icon>
                      <v-icon color="red" class="mr-1" size="18" v-else>mdi-arrow-down-bold</v-icon>
                      {{ formatarPercentual(vendedor.margemad) }}
                    </td>

                    <!-- Atingimento diário -->
                    <td
                        style="height: 23px !important;"
                        :class="projecaoCor(vendedor.peratingimentoad_new)"
                        class="text-center text-truncate"
                    >
                      <v-icon color="blue" class="mr-1" size="18" v-if="vendedor.peratingimentoad_new>=110">mdi-arrow-up-bold</v-icon>
                      <v-icon color="green" class="mr-1" size="18" v-else-if="vendedor.peratingimentoad_new>=100">mdi-arrow-up-bold</v-icon>
                      <v-icon color="orange" class="mr-1" size="18" v-else-if="vendedor.peratingimentoad_new>=90">mdi-minus-thick</v-icon>
                      <v-icon color="red" class="mr-1" size="18" v-else>mdi-arrow-down-bold</v-icon>
                      {{ formatarPercentual(vendedor.peratingimentoad_new) }}
                    </td>

                    <!-- Meta e Venda (valores em R$) -->
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ vendedor.meta | formataDinheiro }}
                      </td>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ vendedor.venda | formataDinheiro }}
                      </td>
                    </v-fade-transition>

                    <!-- Margens -->
                    <td
                        style="height: 23px !important;"
                        :class="margemCorBoni(vendedor.margemac, 24)"
                        class="text-center text-truncate"
                    >
                      <v-icon color="blue" class="mr-1" size="18" v-if="vendedor.margemac>=24">mdi-arrow-up-bold</v-icon>
                      <v-icon color="red" class="mr-1" size="18" v-else>mdi-arrow-down-bold</v-icon>
                      {{ formatarPercentual(vendedor.margemac) }}
                    </td>
                    <!--                  <v-fade-transition hide-on-leave>-->
                    <!--                    <td v-show="mostrarColuna"  style="height: 23px !important;" class="text-center">-->
                    <!--                      24.00 %-->
                    <!--                    </td>-->
                    <!--                  </v-fade-transition>-->

                    <!-- Atingimento Acumulado -->
                    <td
                        style="height: 23px !important;"
                        :class="projecaoCor(vendedor.perprojecao)"
                        class="text-center text-truncate"
                    >
                      <v-icon color="blue" class="mr-1" size="18" v-if="vendedor.perprojecao>=110">mdi-arrow-up-bold</v-icon>
                      <v-icon color="green" class="mr-1" size="18" v-else-if="vendedor.perprojecao>=100">mdi-arrow-up-bold</v-icon>
                      <v-icon color="orange" class="mr-1" size="18" v-else-if="vendedor.perprojecao>=90">mdi-minus-thick</v-icon>
                      <v-icon color="red" class="mr-1" size="18" v-else>mdi-arrow-down-bold</v-icon>
                      {{ formatarPercentual(vendedor.perprojecao) }}
                    </td>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna" style="height: 23px !important;" class="text-center text-no-wrap">
                        {{ vendedor.vendaprojecao | formataDinheiro }}
                      </td>
                    </v-fade-transition>

                    <!-- Bonificação -->
                    <!--                  <v-fade-transition hide-on-leave>-->
                    <!--                    <td-->
                    <!--                        v-show="mostrarColuna"-->
                    <!--                        style="height: 23px !important;"-->
                    <!--                        :class="bonificacaoCor(vendedor.bonificacao)"-->
                    <!--                        class="text-center text-no-wrap font-weight-bold"-->
                    <!--                    >-->
                    <!--                      {{ vendedor.bonificacao | formataDinheiro }}-->
                    <!--                    </td>-->
                    <!--                  </v-fade-transition>-->

                    <!--                  <td style="height: 23px"-->
                    <!--                      :class="perBonificacaoCor(vendedor.perbonificacao)"-->
                    <!--                      class="text-truncate text-center"-->
                    <!--                  >-->
                    <!--                    <v-icon color="blue" class="mr-1" size="18" v-if="vendedor.perbonificacao>=100">mdi-arrow-up-bold</v-icon>-->
                    <!--                    <v-icon color="orange" class="mr-1" size="18" v-else-if="vendedor.perbonificacao>=90">mdi-minus-thick</v-icon>-->
                    <!--                    <v-icon color="red" class="mr-1" size="18" v-else>mdi-arrow-down-bold</v-icon>-->
                    <!--                    {{ vendedor.perbonificacao }}%-->
                    <!--                  </td>-->
                  </tr>
                  </tbody>

                  <!-- Footer com totais Vendedores -->
                  <tfoot v-if="rankingBoniAnalitico.totais && !carregando2">
                  <tr class="primary white--text font-weight-bold">
                    <td class="text-center">-</td>
                    <td class="text-uppercase" colspan="2">TOTAL</td>
                    <v-fade-transition hide-on-leave>
                      <td class="text-center" v-show="mostrarColuna"></td>
                    </v-fade-transition>
                    <td class="text-uppercase" v-if="filtroFilial === null && dataCampanha(busca.dtdia)">{{ rankingCampanha.totais[0]?.vendabonificacao | formataDinheiro }}</td>
                    <td class="text-uppercase" v-else-if="dataCampanha(busca.dtdia)">{{ (rankingCampanha.listaFiliais.find(v => v.idempresa === filtroFilial)?.vendabonificacao || 0) | formataDinheiro }}</td>
                    <td class="text-uppercase" v-if="filtroFilial === null && dataCampanha(busca.dtdia)">{{ rankingCampanha.totais[0]?.comissao | formataDinheiro }}</td>
                    <td class="text-uppercase" v-else-if="dataCampanha(busca.dtdia)">{{ (rankingCampanha.listaFiliais.find(v => v.idempresa === filtroFilial)?.comissao || 0) | formataDinheiro }}</td>
                    <v-fade-transition hide-on-leave>
                      <td class="text-center" v-show="mostrarColuna"></td>
                    </v-fade-transition>
                    <td class="text-center"></td>
                    <td class="text-center"></td>
                    <!-- Meta e Venda totais -->
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna" class="text-center text-no-wrap">
                        {{ rankingBoniAnalitico.totais.meta | formataDinheiro }}
                      </td>
                    </v-fade-transition>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna" class="text-center text-no-wrap">
                        {{ rankingBoniAnalitico.totais.venda | formataDinheiro }}
                      </td>
                    </v-fade-transition>

                    <!-- Margens totais -->
                    <td class="text-center">
                      {{ formatarPercentual(rankingBoniAnalitico.totais.margem) }}
                    </td>
                    <!--                  <v-fade-transition hide-on-leave>-->
                    <!--                    <td v-show="mostrarColuna"  class="text-center">-->
                    <!--                      - -->
                    <!--                    </td>-->
                    <!--                  </v-fade-transition>-->

                    <!-- Projeção total -->
                    <td class="text-center">
                      {{ formatarPercentual(rankingBoniAnalitico.totais.atingimentoac) }}
                    </td>
                    <v-fade-transition hide-on-leave>
                      <td v-show="mostrarColuna" class="text-center text-no-wrap">
                        {{ rankingBoniAnalitico.totais.vendaprojecao | formataDinheiro }}
                      </td>
                    </v-fade-transition>

                    <!-- Bonificação total -->
                    <!--                  <v-fade-transition hide-on-leave>-->
                    <!--                    <td v-show="mostrarColuna" class="text-center text-no-wrap">-->
                    <!--                      {{ rankingBoniAnalitico.totais.bonificacao | formataDinheiro }}-->
                    <!--                    </td>-->
                    <!--                  </v-fade-transition>-->

                    <!--                  <td class="text-center">-->
                    <!--                    - -->
                    <!--                  </td>-->
                  </tr>
                  </tfoot>
                </v-simple-table>
              </v-tab-item>

            </v-tabs-items>
          </v-card-text>

          <v-divider />
          <v-card-actions class="pa-3">
            <v-btn :loading="carregando2" block color="primary" elevation="0"
                   @click="dialogBonificacoes = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogVendas" :max-width="mostrarColuna ? '1200' : '1080'" scrollable>
        <v-card>
          <v-card-title class="primary white--text">
            Ranking diário Vendas - GESTOR | {{ busca.dtdia.split('-').reverse().join('/') }}
            <v-spacer />
            <v-img max-width="220" src="../../assets/icons/logo_min.png" />
          </v-card-title>
          <v-divider />
          <v-card-text class="black--text pt-5 mb-n3">
            <v-simple-table dense style="border: 1px solid #023449">
              <thead>
              <tr class="primary" style="height: 50px;">
                <th class="white--text text-subtitle-2">RK</th>
                <th class="white--text text-subtitle-2 pr-0">Filial</th>

                <!--                <v-fade-transition hide-on-leave>-->
                <!--                  <th v-show="mostrarColuna" class="white&#45;&#45;text text-center text-subtitle-2">-->
                <!--                    Meta Diária Acumulada (R$)</th>-->
                <!--                </v-fade-transition>-->
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">
                    Meta Diária Fixa (R$)</th>
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">
                    Realizado Diário (R$)</th>
                </v-fade-transition>
                <th class="white--text text-center text-subtitle-2 d-flex pl-2">
                  <!-- Tooltip para alternar a visibilidade da coluna -->
                  <v-tooltip color="blue-grey" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="float-left mr-1 mt-1" icon fab x-small v-bind="attrs"
                             @click="mostrarColuna = !mostrarColuna" v-on="on">
                        <v-icon color="white" size="14">
                          {{ mostrarColuna ? 'mdi-eye-off' : 'mdi-eye' }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span class="white--text">
												{{ mostrarColuna ? "Ocultar Venda (R$)" : "Mostrar Venda (R$)" }}
											</span>
                  </v-tooltip>
                  <span class="mt-1">Realizado diário</span>
                </th>
                <th class="white--text text-center text-subtitle-2">Realizado acumulado</th>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">
                    Realizado acumulado (R$)</th>
                </v-fade-transition>
                <th class="white--text text-center text-subtitle-2">Margem diária</th>
                <th class="white--text text-center text-subtitle-2">Margem meta</th>
                <th class="white--text text-center text-subtitle-2">Margem acumulada</th>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">Venda Projetada</th>
                </v-fade-transition>
                <th class="white--text text-center text-subtitle-2">% Venda Projetada</th>
                <th class="white--text text-center text-subtitle-2">% Var. A.A</th>
                <!--                <th class="white&#45;&#45;text text-center text-subtitle-2" style="min-width: 180px;">% Var. Cres. Projeção A.A</th>-->
              </tr>
              </thead>
              <tbody>
              <tr v-for="(u, i) in dialogDados" :key="i" class="font-weight-bold">
                <td style="height: 23px !important;">{{ i + 1 }}</td>
                <td style="height: 23px !important;" class="text-truncate">{{ u.filial }}</td>
                <!--                <v-fade-transition hide-on-leave>-->
                <!--                  <td v-show="mostrarColuna" style="height: 23px !important;" class="text-center">{{-->
                <!--                      u.metadiariaacumulada | formataDinheiro }}</td>-->
                <!--                </v-fade-transition>-->
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna" style="height: 23px !important;" class="text-center text-truncate">{{
                      u.metadia_new | formataDinheiro }}</td>
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna" style="height: 23px !important;" class="text-center text-truncate" :class="realizadoCor(u.perrealiadodiarioac)">{{
                      u.realizadodia |
                          formataDinheiro }}</td>
                </v-fade-transition>
                <td style="height: 23px !important;" :class="realizadoCor(u.perrealiadodiarioac)"
                    class="text-center text-truncate pl-13">{{
                    u.perrealiadodiarioac.toFixed(2) }} %</td>
                <td style="height: 23px !important;" :class="realizadoCor(u.perealizadoac)"
                    class="text-center text-truncate">{{
                    u.perealizadoac.toFixed(2) }} %</td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna" style="height: 23px !important;" :class="realizadoCor(u.perealizadoac)" class="text-center text-truncate">
                    {{ u.realizadoacumuladoac | formataDinheiro }}</td>
                </v-fade-transition>
                <td style="height: 23px !important;" :class="margemCorFilial(u.margemdiaria, margemmeta[filiaisVendas[u.filial]])"
                    class="text-center text-truncate">{{
                    u.margemdiaria.toFixed(2) }} %</td>
                <td style="height: 23px !important;"
                    class="text-center text-truncate">
                  {{margemmeta[filiaisVendas[u.filial]] ? margemmeta[filiaisVendas[u.filial]].toFixed(2) : '-'}} %
                </td>
                <td style="height: 23px !important;" :class="margemCorFilial(u.margemacumuladaac, margemmeta[filiaisVendas[u.filial]])"
                    class="text-center text-truncate">{{
                    u.margemacumuladaac.toFixed(2) }} %</td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna" style="height: 23px !important;" class="text-center text-no-wrap">
                    {{ u.projecaoreal | formataDinheiro }}
                  </td>
                </v-fade-transition>
                <td style="height: 23px !important;" class="text-center text-no-wrap">
                  {{ u.projecaoatingida.toFixed(2) }}%
                </td>
                <!--                <td style="height: 23px !important;" :class="variacaoCor(u.variacao)"-->
                <!--                    class="text-center text-truncate">{{ u.variacao.toFixed(2) }} %</td>-->
                <td style="height: 23px !important;" :class="variacaoCor(u.variacaoprojecaoaa)"
                    class="text-center text-truncate">{{ formatarVariacao(u.variacaoprojecaoaa || 0) }}</td>
              </tr>
              </tbody>
              <tfoot v-if="dashboard.rankingfooter">
              <tr class="primary white--text font-weight-bold">
                <td></td>
                <td>TOTAL</td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna" class="text-center">{{ dashboard.rankingfooter.filter(v => v.regional ==
                      'Todas')[0].metadia_new | formataDinheiro }}</td>
                </v-fade-transition>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna" class="text-center">{{ dashboard.rankingfooter.filter(v => v.regional ==
                      'Todas')[0].realizadodia | formataDinheiro }}</td>
                </v-fade-transition>
                <td class="text-center pl-13">{{ (dashboard.rankingfooter.filter(v => v.regional ==
                    'Todas')[0].perrealizado_new || 0).toFixed(2) }} %</td>
                <td class="text-center">{{ dashboard.rankingfooter.filter(v => v.regional ==
                    'Todas')[0].perealizadoac.toFixed(2) }} %</td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna" class="text-center">{{ dashboard.rankingfooter.filter(v => v.regional ==
                      'Todas')[0].realizadoacumuladoac | formataDinheiro }}</td>
                </v-fade-transition>
                <td class="text-center">{{ dashboard.rankingfooter.filter(v => v.regional ==
                    'Todas')[0].margemdiaria }} %</td>
                <td class="text-center">
                  {{ margemmetatotal ? margemmetatotal.toFixed(2) : '-'  }} %
                </td>
                <td class="text-center">{{ dashboard.rankingfooter.filter(v => v.regional ==
                    'Todas')[0].margemacumuladaac.toFixed(2) }} %</td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna" class="text-center">{{ dashboard.rankingfooter.filter(v => v.regional ==
                      'Todas')[0].projecaoreal | formataDinheiro }}</td>
                </v-fade-transition>
                <td class="text-center">
                  {{ (dashboard.rankingfooter.filter(v => v.regional ==
                    'Todas')[0].projecaoatingida).toFixed(2) }}%
                </td>
                <!--                <td class="text-center">{{ dashboard.rankingfooter.filter(v => v.regional === 'Todas')[0]?.realizadoacumuladoac && dashboard.anoanterior-->
                <!--                    ? ((dashboard.rankingfooter.filter(v => v.regional === 'Todas')[0].realizadoacumuladoac / dashboard.anoanterior - 1) * 100).toFixed(2)-->
                <!--                    : '0.00' }} %</td>-->
                <td class="text-center">
                  {{ formatarVariacao(dashboard.rankingfooter.filter(v => v.regional ==
                    'Todas')[0]?.variacao_cres_proj_aa) }}
                </td>
              </tr>
              </tfoot>
            </v-simple-table>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-3">
            <v-btn :loading="carregando" block color="primary" elevation="0"
                   @click="dialogVendas = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogFaturamento" :max-width="mostrarColuna ? '1180' : '900'" scrollable>
        <v-card>
          <v-card-title class="primary white--text">
            <span>Ranking diário Faturamento DRE - GESTOR | {{ busca.dtdia.split('-').reverse().join('/') }}</span>
            <v-spacer />
            <v-img max-width="220" src="../../assets/icons/logo_min.png" />

          </v-card-title>
          <v-divider />
          <v-card-text class="black--text pt-5 mb-n3">
            <v-simple-table dense style="border: 1px solid #023449">
              <thead>
              <tr class="primary" style="height: 50px;">
                <th class="white--text text-subtitle-2">RK</th>
                <th class="white--text text-subtitle-2 pr-0">Filial</th>
                <th class="white--text text-center text-subtitle-2 d-flex pl-2">
                  <!-- Tooltip para alternar a visibilidade da coluna -->
                  <v-tooltip color="blue-grey" bottom>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn class="float-left mt-1 mr-1" text fab x-small v-bind="attrs"
                             @click="mostrarColuna = !mostrarColuna" v-on="on">
                        <v-icon color="white" size="14">
                          {{ mostrarColuna ? 'mdi-eye-off' : 'mdi-eye' }}
                        </v-icon>
                      </v-btn>
                    </template>
                    <span class="white--text">
												{{ mostrarColuna ? "Ocultar Venda (R$)" : "Mostrar Venda (R$)" }}
											</span>
                  </v-tooltip>
                  <span class="mt-1">Realizado diário</span>
                </th>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">
                    Realizado Diário (R$)</th>
                </v-fade-transition>
                <th class="white--text text-center text-subtitle-2">Realizado acumulado</th>
                <v-fade-transition hide-on-leave>
                  <th v-show="mostrarColuna" class="white--text text-center text-subtitle-2">
                    Realizado Acumulado (R$)</th>
                </v-fade-transition>
                <th class="white--text text-center text-subtitle-2">Margem diária</th>
                <th class="white--text text-center text-subtitle-2">Margem Meta</th>
                <th class="white--text text-center text-subtitle-2">Margem acumulada</th>
                <!--                <th class="white&#45;&#45;text text-center text-subtitle-2">Variação A.A %</th>-->
                <th class="white--text text-center text-subtitle-2">Variação A.A %</th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(u, i) in rankingFat.Fatdre" :key="i" class="font-weight-bold">
                <td style="height: 23px !important;">{{ u.ranking }}</td>
                <td style="height: 23px !important;" class="text-truncate pr-0">{{ u.empresa }}</td>
                <td style="height: 23px !important;" :class="realizadoCor(u.realizadodiarioperc)"
                    class="text-center pl-13" nowrap>
                  {{ u.realizadodiarioperc ? u.realizadodiarioperc.toFixed(2) : '-' }} %
                </td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna" style="height: 23px !important;" :class="realizadoCor(u.realizadodiarioperc)" class="text-center">
                    {{ u.vendadiaria | formataDinheiro }}</td>
                </v-fade-transition>
                <td style="height: 23px !important;" :class="realizadoCor(u.realizadoacumuladoperc)"
                    class="text-center">
                  {{ u.realizadoacumuladoperc ? u.realizadoacumuladoperc.toFixed(2) : '-' }} %
                </td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna" style="height: 23px !important;" :class="realizadoCor(u.realizadoacumuladoperc)" class="text-center">
                    {{ u.vendaacumulada | formataDinheiro }}</td>
                </v-fade-transition>
                <td style="height: 23px !important;" :class="margemCorFilial(u.margemdiaria, margemmeta[String(u.idempresa)])"
                    class="text-center">
                  {{ u.margemdiaria ? u.margemdiaria.toFixed(2) : '-' }} %
                </td>
                <td style="height: 23px !important;" class="text-center">
                  {{ margemmeta[String(u.idempresa)] ? margemmeta[String(u.idempresa)].toFixed(2) : '-'}} %
                </td>
                <td style="height: 23px !important;" :class="margemCorFilial(u.margemacumulada, margemmeta[String(u.idempresa)])"
                    class="text-center">
                  {{ u.margemacumulada ? u.margemacumulada.toFixed(2) : '-' }} %
                </td>
                <!--                <td style="height: 23px !important;" :class="variacaoCor(u.variacaoaa)" class="text-center">-->
                <!--                  {{ u.variacaoaa ? u.variacaoaa.toFixed(2) : '-' }} %-->
                <!--                </td>-->
                <td style="height: 23px !important;" :class="variacaoCor(u.variacaoprojaa || 0)" class="text-center">
                  {{ formatarVariacao(u.variacaoprojaa || 0) }}
                </td>
              </tr>
              </tbody>
              <tfoot v-if="rankingFat">
              <tr class="primary white--text font-weight-bold">
                <td></td>
                <td>TOTAL</td>
                <td class="text-center pl-13">
                  {{ rankingFat.totalrealizadodiarioperc ? rankingFat.totalrealizadodiarioperc.toFixed(2) : '-' }} %
                </td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna" class="text-center">{{ rankingFat.totalvendadiaria | formataDinheiro }}</td>
                </v-fade-transition>
                <td class="text-center">
                  {{ rankingFat.totalrealizadoacumuladoperc ? rankingFat.totalrealizadoacumuladoperc.toFixed(2) : '-' }} %
                </td>
                <v-fade-transition hide-on-leave>
                  <td v-show="mostrarColuna" class="text-center">{{ rankingFat.vendaacumulada | formataDinheiro }}</td>
                </v-fade-transition>
                <td class="text-center">
                  {{ rankingFat.totalmargemdiaria ? rankingFat.totalmargemdiaria.toFixed(2) : '-' }} %
                </td>
                <td class="text-center">
                  {{ margemmetatotal ? margemmetatotal.toFixed(2) : '-'  }} %
                </td>
                <td class="text-center">
                  {{ rankingFat.totalmargemacumulada ? rankingFat.totalmargemacumulada.toFixed(2) : '-' }} %
                </td>
                <!--                <td class="text-center">-->
                <!--                  {{ rankingFat.variacaoaa ? rankingFat.variacaoaa.toFixed(2) : '-'  }} %-->
                <!--                </td>-->
                <td class="text-center">
                  {{ formatarVariacao(rankingFat.variacaoprojaa || 0) }}
                </td>
              </tr>
              </tfoot>
            </v-simple-table>
            <span class="text-caption" style="display: block; text-align: end;">Data Processamento -  {{ rankingFat.dataprocessamento }}</span>
          </v-card-text>
          <v-divider />
          <v-card-actions class="pa-3">
            <v-btn :loading="carregando" block color="primary" elevation="0"
                   @click="dialogFaturamento = false">Fechar</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <v-dialog v-model="dialogBlackFriday" :max-width="mostrarValores ? '1580' : '900'" scrollable>
        <v-card>
          <v-card-title class="black white--text" style="background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);">
            <div class="d-flex align-center" style="width: 100%;">
              <v-icon color="yellow accent-3" class="mr-2" size="28">mdi-tag-multiple</v-icon>
              <div>
                <div class="text-h6 font-weight-bold">
                  <span class="yellow--text text--accent-3">BLACK</span>
                  <span class="white--text"> FRIDAY</span>
                  <span class="text--accent-2"> 2025</span>
                </div>
                <div class="text-caption grey--text text--lighten-1">
                  Acompanhamento de Vendas e Metas
                </div>
              </div>
              <v-spacer />
              <v-img max-width="220" src="../../assets/icons/logo_min.png" />
            </div>
          </v-card-title>

          <v-divider class="yellow accent-3" style="border-width: 2px;" />

          <v-card-text class="black--text pt-5 mb-n3">
            <!-- LOADING STATE -->
            <div v-if="carregandoBlackFriday" class="text-center py-12">
              <v-progress-circular
                  :size="80"
                  :width="8"
                  color="yellow accent-3"
                  indeterminate
              >
                <v-icon color="yellow accent-3" size="40">mdi-tag-multiple</v-icon>
              </v-progress-circular>
              <div class="mt-6">
                <div class="text-h6 font-weight-bold black--text mb-2">
                  Carregando dados da Black Friday...
                </div>
                <div class="text-body-2 grey--text">
                  Aguarde enquanto processamos as informações
                </div>
              </div>

              <!-- SKELETON LOADER -->
              <v-container class="mt-8">
                <v-row>
                  <v-col cols="12">
                    <v-sheet
                        color="grey lighten-4"
                        class="pa-4 rounded-lg"
                        elevation="0"
                    >
                      <v-skeleton-loader
                          type="heading, text, text"
                          :loading="true"
                      />
                    </v-sheet>
                  </v-col>
                </v-row>
              </v-container>
            </div>

            <!-- TABELA DE DADOS -->
            <div v-else>

              <!-- TABELA -->
              <v-simple-table
                  dense
                  style="border: 2px solid #1a1a1a; border-radius: 8px; overflow: hidden;"
              >
                <thead>
                <tr style="height: 50px; background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);">
                  <th class="white--text text-subtitle-2">
                    <v-icon color="yellow accent-3" size="18" class="mr-1">mdi-trophy</v-icon>
                    RK
                  </th>
                  <th class="white--text text-subtitle-2 pr-0">
                    <div class="d-flex align-center justify-space-between">
                      <span>Filial</span>
                      <v-tooltip color="black" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn
                              class="ml-2"
                              icon
                              small
                              v-bind="attrs"
                              @click="mostrarValores = !mostrarValores"
                              v-on="on"
                              style="background: rgba(255, 255, 255, 0.1);"
                          >
                            <v-icon color="yellow accent-3" size="18">
                              {{ mostrarValores ? 'mdi-eye-off' : 'mdi-eye' }}
                            </v-icon>
                          </v-btn>
                        </template>
                        <span class="white--text">
                      {{ mostrarValores ? "Ocultar Valores (R$)" : "Mostrar Valores (R$)" }}
                    </span>
                      </v-tooltip>
                    </div>
                  </th>

                  <!-- SEXTA-FEIRA -->
                  <v-fade-transition hide-on-leave>
                    <th v-show="mostrarValores" class="white--text text-center text-subtitle-2">
                      Venda Sexta (R$)
                    </th>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <th v-show="mostrarValores" class="white--text text-center text-subtitle-2">
                      Meta Sexta (R$)
                    </th>
                  </v-fade-transition>
                  <th class="white--text text-center text-subtitle-2">
                    Ating. Sexta (%)
                  </th>
                  <th class="white--text text-center text-subtitle-2">
                    Margem Sexta (%)
                  </th>

                  <!-- SÁBADO -->
                  <v-fade-transition hide-on-leave>
                    <th v-show="mostrarValores" class="white--text text-center text-subtitle-2">
                      Venda Sábado (R$)
                    </th>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <th v-show="mostrarValores" class="white--text text-center text-subtitle-2">
                      Meta Sábado (R$)
                    </th>
                  </v-fade-transition>
                  <th class="white--text text-center text-subtitle-2">
                    Ating. Sábado (%)
                  </th>
                  <th class="white--text text-center text-subtitle-2">
                    Margem Sábado (%)
                  </th>

                  <!-- TOTAL -->
                  <v-fade-transition hide-on-leave>
                    <th v-show="mostrarValores" class="white--text text-center text-subtitle-2">
                      Venda Total (R$)
                    </th>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <th v-show="mostrarValores" class="white--text text-center text-subtitle-2">
                      Meta Total (R$)
                    </th>
                  </v-fade-transition>
                  <th class="white--text text-center text-subtitle-2">
                    Ating. Total (%)
                  </th>
                </tr>
                </thead>
                <tbody>
                <tr
                    v-for="(item, i) in blackFridayDados"
                    :key="i"
                    class="font-weight-bold"
                    :style="i % 2 === 0 ? 'background: #fafafa;' : ''"
                >
                  <td style="height: 23px !important;">
                    <v-chip
                        small
                        :color="getRankingColor(i + 1)"
                        dark
                        class="font-weight-bold"
                    >
                      {{ i + 1 }}º
                    </v-chip>
                  </td>
                  <td style="height: 23px !important;" class="text-truncate">{{ item.empresa }}</td>

                  <!-- SEXTA-FEIRA -->
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarValores" style="height: 23px !important;" class="text-center text-truncate">
                      {{ item.venda_sexta | formataDinheiro }}
                    </td>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarValores" style="height: 23px !important;" class="text-center text-truncate">
                      {{ item.meta_sexta | formataDinheiro }}
                    </td>
                  </v-fade-transition>
                  <td
                      style="height: 23px !important;"
                      :class="atingimentoCor(item.atingimento_sexta)"
                      class="text-center text-truncate font-weight-bold"
                  >
                    {{ item.atingimento_sexta.toFixed(2) }} %
                  </td>
                  <td
                      style="height: 23px !important;"
                      :class="margemCor(item.margem_sexta)"
                      class="text-center text-truncate font-weight-bold"
                  >
                    {{ item.margem_sexta.toFixed(2) }} %
                  </td>

                  <!-- SÁBADO -->
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarValores" style="height: 23px !important;" class="text-center text-truncate">
                      {{ item.venda_sabado | formataDinheiro }}
                    </td>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarValores" style="height: 23px !important;" class="text-center text-truncate">
                      {{ item.meta_sabado | formataDinheiro }}
                    </td>
                  </v-fade-transition>
                  <td
                      style="height: 23px !important;"
                      :class="atingimentoCor(item.atingimento_sabado)"
                      class="text-center text-truncate font-weight-bold"
                  >
                    {{ item.atingimento_sabado.toFixed(2) }} %
                  </td>
                  <td
                      style="height: 23px !important;"
                      :class="margemCor(item.margem_sabado)"
                      class="text-center text-truncate font-weight-bold"
                  >
                    {{ item.margem_sabado.toFixed(2) }} %
                  </td>

                  <!-- TOTAL -->
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarValores" style="height: 23px !important;" class="text-center text-truncate">
                      {{ item.venda_total | formataDinheiro }}
                    </td>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarValores" style="height: 23px !important;" class="text-center text-truncate">
                      {{ item.meta_total | formataDinheiro }}
                    </td>
                  </v-fade-transition>
                  <td
                      style="height: 23px !important;"
                      :class="atingimentoCor(item.atingimento_total)"
                      class="text-center text-truncate font-weight-bold"
                  >
                    {{ item.atingimento_total.toFixed(2) }} %
                  </td>
                </tr>
                </tbody>
                <tfoot v-if="blackFridayTotais">
                <tr style="height: 50px; background: linear-gradient(135deg, #1a1a1a 0%, #2d2d2d 100%);">
                  <td></td>
                  <td class="white--text font-weight-bold">
                    <v-icon color="yellow accent-3" size="18" class="mr-1">mdi-sigma</v-icon>
                    TOTAL
                  </td>

                  <!-- SEXTA-FEIRA -->
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarValores" class="text-center white--text font-weight-bold">
                      {{ blackFridayTotais.venda_sexta | formataDinheiro }}
                    </td>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarValores" class="text-center white--text font-weight-bold">
                      {{ blackFridayTotais.meta_sexta | formataDinheiro }}
                    </td>
                  </v-fade-transition>
                  <td class="text-center white--text font-weight-bold">
                    {{ blackFridayTotais.atingimento_sexta.toFixed(2) }} %
                  </td>
                  <td class="text-center white--text font-weight-bold">
                    {{ blackFridayTotais.margem_sexta.toFixed(2) }} %
                  </td>

                  <!-- SÁBADO -->
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarValores" class="text-center white--text font-weight-bold">
                      {{ blackFridayTotais.venda_sabado | formataDinheiro }}
                    </td>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarValores" class="text-center white--text font-weight-bold">
                      {{ blackFridayTotais.meta_sabado | formataDinheiro }}
                    </td>
                  </v-fade-transition>
                  <td class="text-center white--text font-weight-bold">
                    {{ blackFridayTotais.atingimento_sabado.toFixed(2) }} %
                  </td>
                  <td class="text-center white--text font-weight-bold">
                    {{ blackFridayTotais.margem_sabado.toFixed(2) }} %
                  </td>

                  <!-- TOTAL -->
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarValores" class="text-center white--text font-weight-bold">
                      {{ blackFridayTotais.venda_total | formataDinheiro }}
                    </td>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarValores" class="text-center white--text font-weight-bold">
                      {{ blackFridayTotais.meta_total | formataDinheiro }}
                    </td>
                  </v-fade-transition>
                  <td class="text-center white--text font-weight-bold">
                    {{ blackFridayTotais.atingimento_total.toFixed(2) }} %
                  </td>
                </tr>
                </tfoot>
              </v-simple-table>
            </div>
          </v-card-text>

          <v-divider class="yellow accent-3" style="border-width: 2px;" />

          <v-card-actions class="pa-3" style="background: #fafafa;">
            <v-btn
                :loading="carregandoBlackFriday"
                block
                color="black"
                dark
                elevation="2"
                class="font-weight-bold"
                @click="dialogBlackFriday = false"
            >
              <v-icon left>mdi-close</v-icon>
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG BONIFICAÇÃO E-BOOK (DIRETORIA) -->
      <v-dialog v-model="dialogBonificacaoEbook" :max-width="mostrarColunasEbook ? '1280' : '900'" scrollable>
        <v-card>
          <v-card-title class="white--text" style="background: linear-gradient(135deg, #0B5C73 0%, #074464 100%);">
            <div class="d-flex align-center" style="width: 100%;">
              <v-icon color="white" class="mr-2" size="28">mdi-book-open-page-variant</v-icon>
              <div>
                <div class="text-h6 font-weight-bold">Educa Comercial Ivaiporã</div>
                <div class="text-caption">Campanha de bonificação E-book · ranking geral da rede — top 10 premiados</div>
              </div>
              <v-spacer />
              <v-img max-width="220" src="../../assets/icons/logo_min.png" />
            </div>
          </v-card-title>

          <v-divider />

          <v-card-text class="black--text pt-5 pb-4">
            <div v-if="carregandoEbook" class="text-center py-12">
              <v-progress-circular :size="80" :width="8" color="primary" indeterminate>
                <v-icon color="primary" size="40">mdi-book-open-page-variant</v-icon>
              </v-progress-circular>
              <div class="mt-6 text-h6 font-weight-bold black--text">Carregando ranking da campanha...</div>
            </div>

            <div v-else>
              <v-simple-table dense style="border: 1px solid #023449">
                <thead>
                <tr class="primary" style="height: 50px;">
                  <th class="white--text text-subtitle-2" style="width: 52px;">RK</th>
                  <th class="white--text text-subtitle-2">Vendedor</th>
                  <th class="white--text text-subtitle-2">Filial</th>
                  <th class="white--text text-center text-subtitle-2">Pontos</th>
                  <th class="white--text text-subtitle-2">
                    <div class="d-flex align-center justify-center">
                      <v-tooltip color="blue-grey" bottom>
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn class="mr-1" icon fab x-small v-bind="attrs"
                                 @click="mostrarColunasEbook = !mostrarColunasEbook" v-on="on">
                            <v-icon color="white" size="14">
                              {{ mostrarColunasEbook ? 'mdi-eye-off' : 'mdi-eye' }}
                            </v-icon>
                          </v-btn>
                        </template>
                        <span class="white--text">
                          {{ mostrarColunasEbook ? "Ocultar qtde. e valor de e-books" : "Mostrar qtde. e valor de e-books" }}
                        </span>
                      </v-tooltip>
                      <span>Premiação</span>
                    </div>
                  </th>
                  <v-fade-transition hide-on-leave>
                    <th v-show="mostrarColunasEbook" class="white--text text-center text-subtitle-2">Qtde vendas c/ e-book</th>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <th v-show="mostrarColunasEbook" class="white--text text-center text-subtitle-2">Qtde e-books</th>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <th v-show="mostrarColunasEbook" class="white--text text-center text-subtitle-2">Valor e-books</th>
                  </v-fade-transition>
                </tr>
                </thead>
                <tbody v-if="rankingEbook.lista.length">
                <tr
                    v-for="item in rankingEbook.lista"
                    :key="item.idvendedor"
                    class="font-weight-bold"
                    :style="item.flag_premiado === 'T' ? 'background: #fff8e1;' : ''"
                >
                  <td style="height: 23px !important; width: 52px;" class="pr-0">
                    <v-chip small :color="getRankingColor(item.posicao)" dark class="font-weight-bold px-2">
                      {{ item.posicao }}º
                    </v-chip>
                  </td>
                  <td style="height: 23px !important; width:180px; max-width: 220px !important;" class="text-truncate" :title="item.vendedor">
                    <v-tooltip v-if="item.flag_gerente === 'T'" color="blue-grey" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <v-icon v-bind="attrs" v-on="on" size="18" color="deep-orange darken-1" class="mr-1">mdi-account-tie</v-icon>
                      </template>
                      <span class="white--text">Gerente — não participa da campanha</span>
                    </v-tooltip>
                    {{ item.vendedor }}
                  </td>
                  <td style="height: 23px !important; width:140px; max-width: 180px !important;" class="text-truncate" :title="item.empresa">
                    {{ item.empresa }}
                  </td>
                  <td
                      style="height: 23px !important; cursor: pointer;"
                      class="text-center primary--text text-decoration-underline"
                      :title="`Ver pedidos de ${item.vendedor}`"
                      @click="abrirPedidosEbook(item)"
                  >
                    {{ item.total_pontos }}
                    <v-icon size="14" color="primary" class="ml-1">mdi-magnify-plus-outline</v-icon>
                  </td>
                  <td style="height: 23px !important;" class="text-center">
                    {{ premiacaoEbookDoItem(item) }}
                  </td>
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarColunasEbook" style="height: 23px !important;" class="text-center">{{ item.total_vendas }}</td>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarColunasEbook" style="height: 23px !important;" class="text-center">{{ item.total_qtd_ebook }}</td>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarColunasEbook" style="height: 23px !important;" class="text-center">{{ formatarMoeda(item.total_valor_ebook) }}</td>
                  </v-fade-transition>
                </tr>
                </tbody>
                <tbody v-else>
                <tr>
                  <td colspan="8" class="text-center py-4">Nenhum vendedor pontuou ainda neste mês.</td>
                </tr>
                </tbody>
                <tfoot v-if="rankingEbook.lista.length">
                <tr class="primary white--text font-weight-bold" style="height: 40px;">
                  <td colspan="3" class="text-uppercase">Total</td>
                  <td class="text-center">{{ totaisRankingEbook.totalPontos }}</td>
                  <td class="text-center">{{ formatarMoeda(totaisRankingEbook.totalPremiacao) }}</td>
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarColunasEbook" class="text-center">{{ totaisRankingEbook.totalVendas }}</td>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarColunasEbook" class="text-center">{{ totaisRankingEbook.totalQtdEbook }}</td>
                  </v-fade-transition>
                  <v-fade-transition hide-on-leave>
                    <td v-show="mostrarColunasEbook" class="text-center">{{ formatarMoeda(totaisRankingEbook.totalValorEbook) }}</td>
                  </v-fade-transition>
                </tr>
                </tfoot>
              </v-simple-table>
            </div>
          </v-card-text>

          <v-divider />

          <v-card-actions class="pa-3">
            <v-btn
                outlined
                color="green darken-2"
                elevation="0"
                class="font-weight-bold"
                :disabled="!rankingEbook.lista.length"
                @click="exportarRankingEbookExcel"
            >
              <v-icon left>mdi-microsoft-excel</v-icon>
              Exportar Top 15
            </v-btn>
            <v-spacer />
            <v-btn
                color="primary"
                elevation="2"
                class="font-weight-bold"
                @click="dialogBonificacaoEbook = false"
            >
              <v-icon left>mdi-close</v-icon>
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- DIALOG PEDIDOS DO VENDEDOR (DIRETORIA) -->
      <v-dialog v-model="dialogPedidosEbook" max-width="1000" scrollable>
        <v-card>
          <v-card-title class="white--text" style="background: linear-gradient(135deg, #0B5C73 0%, #074464 100%);">
            <div class="d-flex align-center" style="width: 100%;">
              <v-icon color="white" class="mr-2" size="24">mdi-receipt-text-outline</v-icon>
              <div>
                <div class="text-h6 font-weight-bold">{{ vendedorSelecionadoEbook ? vendedorSelecionadoEbook.vendedor : '' }}</div>
                <div class="text-caption">Pedidos que compõem a pontuação na campanha e-book do mês</div>
              </div>
              <v-spacer />
              <v-btn icon @click="dialogPedidosEbook = false">
                <v-icon color="white">mdi-close</v-icon>
              </v-btn>
            </div>
          </v-card-title>

          <v-divider />

          <v-card-text class="black--text pt-5 mb-n3">
            <div v-if="carregandoPedidosEbook" class="text-center py-12">
              <v-progress-circular :size="60" :width="6" color="primary" indeterminate></v-progress-circular>
            </div>

            <v-simple-table v-else dense light style="border: 1px solid #023449">
              <thead>
              <tr class="primary" style="height: 44px;">
                <th class="white--text text-subtitle-2">Pedido</th>
                <th class="white--text text-subtitle-2">Cliente</th>
                <th class="white--text text-subtitle-2">Data</th>
                <th class="white--text text-center text-subtitle-2">Valor líquido</th>
                <th class="white--text text-center text-subtitle-2">Qtde e-books</th>
                <th class="white--text text-center text-subtitle-2">Valor e-books</th>
                <th class="white--text text-center text-subtitle-2">Pontos</th>
              </tr>
              </thead>
              <tbody v-if="pedidosEbook.length">
              <tr v-for="pedido in pedidosEbook" :key="pedido.numdoc" class="font-weight-bold">
                <td style="height: 23px !important;">{{ pedido.numdoc }}</td>
                <td style="height: 23px !important; max-width: 200px;" class="text-truncate" :title="pedido.cliente">{{ pedido.cliente }}</td>
                <td style="height: 23px !important;">{{ pedido.dtmovimento }}</td>
                <td style="height: 23px !important;" class="text-center">{{ formatarMoeda(pedido.valtotliquido) }}</td>
                <td style="height: 23px !important;" class="text-center">{{ pedido.qtdproduto_ebook }}</td>
                <td style="height: 23px !important;" class="text-center">{{ formatarMoeda(pedido.valtotliquido_ebook) }}</td>
                <td style="height: 23px !important;" class="text-center">{{ pedido.pontos }}</td>
              </tr>
              </tbody>
              <tbody v-else>
              <tr>
                <td colspan="7" class="text-center py-4">Nenhum pedido encontrado.</td>
              </tr>
              </tbody>
              <tfoot v-if="pedidosEbook.length">
              <tr class="primary white--text font-weight-bold" style="height: 40px;">
                <td colspan="3" class="text-uppercase">Total</td>
                <td class="text-center">{{ formatarMoeda(totaisPedidosEbook.totalValorLiquido) }}</td>
                <td class="text-center">{{ totaisPedidosEbook.totalQtdEbook }}</td>
                <td class="text-center">{{ formatarMoeda(totaisPedidosEbook.totalValorEbook) }}</td>
                <td class="text-center">{{ totaisPedidosEbook.totalPontos }}</td>
              </tr>
              </tfoot>
            </v-simple-table>
          </v-card-text>

          <v-divider />

          <v-card-actions class="pa-3">
            <v-btn
                block
                color="primary"
                elevation="2"
                class="font-weight-bold"
                @click="dialogPedidosEbook = false"
            >
              <v-icon left>mdi-close</v-icon>
              Fechar
            </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>

      <!-- FILTROS -->
      <v-col cols="12" md="12">
        <v-card>
          <v-card-text>
            <v-form>
              <v-row class="mb-n4">
                <v-col class="px-3">
                  <InputDatePicker :disabled="carregando" v-model="busca.dtdia" label="Data"
                                   :outlined="true" :dense="true"/>
                </v-col>
              </v-row>
            </v-form>
          </v-card-text>
          <v-card-actions class="px-2 px-sm-4 my-0 pt-0 flex-column flex-sm-row">
            <v-spacer/>
            <!-- Seção superior: Timer e Switch -->
            <div class="align-center justify-space-between w-100 d-none d-md-flex">
              <small v-if="autoRefresh && !carregando" class="text--secondary text-caption">
                Próxima atualização em: {{ tempoRefresh }} segundos
              </small>
              <v-spacer class="d-none d-sm-flex" />
              <v-switch
                  hide-details
                  :loading="carregando"
                  v-model="autoRefresh"
                  :label="$vuetify.breakpoint.xsOnly ? 'Auto' : 'Atualização automática'"
                  color="primary"
                  class="my-0 py-0 mx-1"
              />
            </div>

            <!-- Seção inferior: Botões -->
            <div class="d-flex flex-wrap justify-end w-100">
              <v-btn
                  :loading="carregando"
                  :small="$vuetify.breakpoint.smAndUp"
                  :x-small="$vuetify.breakpoint.xsOnly"
                  color="black"
                  class="ma-1 flex-grow-1 flex-sm-grow-0 yellow--text"
                  elevation="0"
                  @click="abrirDialogBlackFriday"
                  v-if="permissao('dashboard_ranking_botao_blackfriday')"
              >
                Black Friday
                <v-icon :size="$vuetify.breakpoint.xsOnly ? 16 : 18" class="ml-1 ml-sm-2">
                  mdi-magnify
                </v-icon>
              </v-btn>

              <CampanhaVendaMargem />

              <v-btn
                  :small="$vuetify.breakpoint.smAndUp"
                  :x-small="$vuetify.breakpoint.xsOnly"
                  color="teal darken-3"
                  class="ma-1 flex-grow-1 flex-sm-grow-0 white--text"
                  elevation="0"
                  @click="dialogBonificacaoEbook = true"
                  v-if="permissao('dashboard_ranking_bonificacao_ebook_diretoria')"
              >
                Educa Comercial Ivaiporã
                <v-progress-circular
                    v-if="carregandoEbook"
                    indeterminate
                    color="white"
                    :size="$vuetify.breakpoint.xsOnly ? 14 : 16"
                    width="2"
                    class="ml-1 ml-sm-2"
                />
                <v-icon v-else :size="$vuetify.breakpoint.xsOnly ? 16 : 18" class="ml-1 ml-sm-2">
                  mdi-book-open-page-variant
                </v-icon>
              </v-btn>

              <v-btn
                  :loading="carregando"
                  :small="$vuetify.breakpoint.smAndUp"
                  :x-small="$vuetify.breakpoint.xsOnly"
                  color="primary"
                  class="ma-1 flex-grow-1 flex-sm-grow-0"
                  elevation="0"
                  @click="dialogBonificacoes = true"
                  v-if="permissao('dashboard_ranking_botao_bonificacoes')"
              >
                Vendedores
                <v-icon :size="$vuetify.breakpoint.xsOnly ? 16 : 18" class="ml-1 ml-sm-2">
                  mdi-magnify
                </v-icon>
              </v-btn>

              <v-btn
                  :loading="carregando"
                  :small="$vuetify.breakpoint.smAndUp"
                  :x-small="$vuetify.breakpoint.xsOnly"
                  color="primary"
                  class="ma-1 flex-grow-1 flex-sm-grow-0"
                  elevation="0"
                  @click="dialogVendas = true;"
              >
                Vendas
                <v-icon :size="$vuetify.breakpoint.xsOnly ? 16 : 18" class="ml-1 ml-sm-2">
                  mdi-magnify
                </v-icon>
              </v-btn>

              <v-btn
                  :loading="carregando"
                  :small="$vuetify.breakpoint.smAndUp"
                  :x-small="$vuetify.breakpoint.xsOnly"
                  color="primary"
                  class="ma-1 flex-grow-1 flex-sm-grow-0"
                  elevation="0"
                  @click="dialogFaturamento = true"
              >
                Faturamento
                <v-icon :size="$vuetify.breakpoint.xsOnly ? 16 : 18" class="ml-1 ml-sm-2">
                  mdi-magnify
                </v-icon>
              </v-btn>
            </div>
          </v-card-actions>
        </v-card>
      </v-col>

      <!-- CARDS -->
      <v-col cols="12" md="12">
        <v-row class="pa-2">
          <v-col class="pa-1">
            <CardDashboard :loading="carregando" :title="`Atingimento diário (Rede)`">
              <template v-if="dashboard.rankingfooter">{{
                  dashboard.rankingfooter[dashboard.rankingfooter.length
                  - 1].perrealizado_new.toFixed(2) }}%</template>
              <template v-else>0.00 %</template>
              <MenuInfo texto="Atingimento da venda realizada no dia em relação a meta de venda do dia" />
            </CardDashboard>
          </v-col>
          <v-col class="pa-1">
            <CardDashboard :loading="carregando" :title="`Atingimento acumulado (Rede)`">
              <template v-if="dashboard.rankingfooter">{{
                  dashboard.rankingfooter[dashboard.rankingfooter.length
                  - 1].perealizadoac.toFixed(2) }}%</template>
              <template v-else>0.00 %</template>
              <MenuInfo
                  texto="Atingimento da venda realizada acumulada em relação a meta de venda acumulada" />
            </CardDashboard>
          </v-col>
          <v-col class="pa-1">
            <CardDashboard :loading="carregando" title="Dias trabalhados">
              <template v-if="dashboard.diames">{{ dashboard.diames }}</template>
              <template v-else>0</template>
              <MenuInfo texto="Dias trabalhados (úteis) no mês" />
            </CardDashboard>
          </v-col>
        </v-row>
      </v-col>

      <!-- GRAFICOS -->
      <v-col cols="12" class="d-none d-md-block">
        <v-card>
          <v-card-title>
            Atingimento de venda diária sobre meta
            <v-spacer />
            <v-img class="mx-auto" max-width="220" src="../../assets/icons/logo_dark_min.png" />
          </v-card-title>
          <v-card-text v-if="!carregando">
            <v-row v-if="dashboard.rankingbody">
              <v-col>
                <GraficoBarDashboard :dataSeries="[
									{
										name: 'Porcentagem',
										data: dashboard.rankingbody.map((v) => v.perrealizado_new.toFixed(2)),
									},
								]" :categories="dashboard.rankingbody.map((v) => v.filial)" height="300" :money="false" :porcentagem="true"
                                     rotate="-50" :distributed="true" :dataLabels="{
										position: 'bottom',
										orientation: 'vertical',
										offsetY: 10,
									}" :color="corMod1(dashboard.rankingbody, 'perrealizado_new')" />
              </v-col>
            </v-row>
            <span v-else>Nenhum registro encontrado</span>
          </v-card-text>
          <v-card-text v-else>
            <v-skeleton-loader class="mx-auto" width="100%" height="350"
                               type="image, image"></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="d-block d-md-none">
        <v-card>
          <v-progress-linear indeterminate absolute :active="carregando" />
          <v-card-title>
            Atingimento de venda diária sobre meta
            <v-spacer />
            <v-img class="mx-auto" max-width="220" src="../../assets/icons/logo_dark_min.png" />
          </v-card-title>
          <v-card-text v-if="carregando">
            <v-skeleton-loader class="mx-auto" width="100%" height="300"
                               type="image, image"></v-skeleton-loader>
          </v-card-text>
          <v-card-text v-else>
            <template v-if="dashboard.rankingbody">
              <v-simple-table dense>
                <tbody>
                <tr v-for="(u, i) in dashboard.rankingbody" :key="i">
                  <td style="height: 22px" width="30%" class="text-truncate text-caption">
                    {{ u.filial }}</td>
                  <td style="height: 22px">
                    <v-progress-linear rounded :value="u.perrealizado"
                                       :color="shadeColor('#002D56', 100 - u.perrealizado / 3)"
                                       class="white--text" height="17">
                      <template v-slot:default="{ value }">
                        <span class="text-caption">{{ value.toFixed(2) }}%</span>
                      </template>
                    </v-progress-linear>
                  </td>
                </tr>
                </tbody>
              </v-simple-table>
            </template>
            <span v-else>Nenhum registro encontrado</span>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="d-none d-md-block">
        <v-card>
          <v-card-title>
            Atingimento de venda acumulada sobre meta
            <v-spacer />
            <v-img class="mx-auto" max-width="220" src="../../assets/icons/logo_dark_min.png" />
          </v-card-title>
          <v-card-text v-if="!carregando">
            <v-row v-if="dashboard.rankingbody">
              <v-col>
                <GraficoBarDashboard :dataSeries="[
									{
										name: 'Porcentagem',
										data: dashboard.rankingbody.map((v) =>
											v.perealizadoac.toFixed(2)
										),
									},
								]" :categories="dashboard.rankingbody.map((v) => v.filial)" height="300" :money="false" :porcentagem="true"
                                     rotate="-50" :distributed="true" :dataLabels="{
										position: 'bottom',
										orientation: 'vertical',
										offsetY: 10,
									}" :color="corMod1(dashboard.rankingbody, 'perealizadoac')" />
              </v-col>
            </v-row>
            <span v-else>Nenhum registro encontrado</span>
          </v-card-text>
          <v-card-text v-else>
            <v-skeleton-loader class="mx-auto" width="100%" height="350"
                               type="image, image"></v-skeleton-loader>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols="12" class="d-block d-md-none">
        <v-card>
          <v-progress-linear indeterminate absolute :active="carregando" />
          <v-card-title>
            Atingimento de venda acumulada sobre meta
            <v-spacer />
            <v-img class="mx-auto" max-width="220" src="../../assets/icons/logo_dark_min.png" />
          </v-card-title>
          <v-card-text v-if="carregando">
            <v-skeleton-loader class="mx-auto" width="100%" height="300"
                               type="image, image"></v-skeleton-loader>
          </v-card-text>
          <v-card-text v-else>
            <template v-if="dashboard.rankingbody">
              <v-simple-table dense>
                <tbody>
                <tr v-for="(u, i) in dashboard.rankingbody" :key="i">
                  <td style="height: 22px" width="30%" class="text-truncate text-caption">
                    {{ u.filial }}</td>
                  <td style="height: 22px">
                    <v-progress-linear rounded :value="u.perealizadoac"
                                       :color="shadeColor('#002D56', 100 - u.perealizadoac / 3)"
                                       class="white--text" height="17">
                      <template v-slot:default="{ value }">
                        <span class="text-caption">{{ value.toFixed(2) }}%</span>
                      </template>
                    </v-progress-linear>
                  </td>
                </tr>
                </tbody>
              </v-simple-table>
            </template>
            <span v-else>Nenhum registro encontrado</span>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- PANELS -->
      <v-col cols="12">
        <v-expansion-panels v-model="panel" multiple>
          <v-expansion-panel active-class="primary white--text">
            <v-expansion-panel-header class="text-h6">
              Ranking diário de vendas
              <template v-slot:actions>
                <v-icon color="white" class="mr-n6">$expand</v-icon>
                <v-icon>$expand</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table v-if="dashboard.rankingbody" dense :headers="headerDiario" :items="diario"
                            sort-by="perrealizado" :sort-desc="true" :items-per-page="28" hide-default-footer
                            class="elevation-0" fixed-header height="70vh">
                <template slot="body.append">
                  <tr class="d-none d-sm-table-row" v-for="(u, i) in dashboard.rankingfooter" :key="i"
                      :class="u.regional == 'Todas' ? 'blue-grey lighten-4' : 'blue lighten-4'">
                    <td width="5%"></td>
                    <td width="22%" class="font-weight-bold text-uppercase text-truncate">
                      {{ u.regional == "Todas" ? `Total` : `Regional ${u.regional}` }}</td>
                    <td width="15%" v-if="permissao('dashboard_ranking_vendas_valores')"
                        class="font-weight-bold">{{ u.metadia | formataDinheiro }}</td>
                    <td width="18%" v-if="permissao('dashboard_ranking_vendas_valores')"
                        class="font-weight-bold">{{ u.realizadodia | formataDinheiro }}</td>
                    <td width="18%" class="text-truncate font-weight-bold">
                      <template v-if="u.perrealizado">{{ u.perrealizado.toFixed(2) }}</template>
                      <template v-else>0.00</template>
                    </td>
                    <td width="22%" class="text-truncate font-weight-bold">
                      <template v-if="u.margemdiaria">{{ u.margemdiaria.toFixed(2) }}</template>
                      <template v-else>0.00</template>
                    </td>
                  </tr>
                </template>

                <template slot="body.append">
                  <v-data-iterator class="d-flex d-sm-none mt-3" :items="dashboard.rankingbody.map((u) => {
										return {
											regional: u.regional,
											metadia: u.metadia,
											realizadodia: u.realizadodia,
											perrealizado: u.perrealizado,
											margemdiaria: u.margemdiaria,
										};
									})" disable-filtering disable-pagination disable-sort hide-default-footer>
                    <v-row>
                      <v-flex v-for="(u, i) in dashboard.rankingfooter" :key="i" cols="12"
                              class="px-2 py-0">
                        <v-card
                            :class="u.regional == 'Todas' ? 'blue-grey lighten-3' : 'blue lighten-3'">
                          <v-card-title class="subheading font-weight-bold">{{ u.regional ==
                          "Todas" ? `Total` : `Regional ${u.regional}` }}</v-card-title>
                          <v-divider />
                          <v-list dense
                                  :class="u.regional == 'Todas' ? 'blue-grey lighten-4' : 'blue lighten-4'">
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">META
                                DIÁRIA</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>{{ u.metadia | formataDinheiro
                                  }}</v-list-item-content>
                              </div>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">REALIZADO
                                DIÁRIO</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>{{ u.realizadodia | formataDinheiro
                                  }}</v-list-item-content>
                              </div>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">REALIZADO
                                (%)</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>
                                  <template v-if="u.perrealizado">{{
                                      u.perrealizado.toFixed(2) }}</template>
                                  <template v-else>0.00</template>
                                </v-list-item-content>
                              </div>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">MARGEM DIÁRIA
                                (%)</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>
                                  <template v-if="u.margemdiaria">{{
                                      u.margemdiaria.toFixed(2) }}</template>
                                  <template v-else>0.00</template>
                                </v-list-item-content>
                              </div>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-flex>
                    </v-row>
                  </v-data-iterator>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel active-class="primary white--text">
            <v-expansion-panel-header class="text-h6">
              Ranking diário de vendas (acumulado)
              <template v-slot:actions>
                <v-icon color="white" class="mr-n6">$expand</v-icon>
                <v-icon>$expand</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table v-if="dashboard.rankingbody" dense :headers="headerAcumulado" :items="dashboard.rankingbody.map((u) => {
								return {
									rk: u.rk,
									filial: u.filial,
									metaacumuladaac: parseFloat(u.metaacumuladaac).toLocaleString('pt-br', { style: 'currency', currency: 'BRL', }),
									realizadoacumuladoac: parseFloat(u.realizadoacumuladoac).toLocaleString('pt-br', { style: 'currency', currency: 'BRL', }),
									perealizadoac: parseFloat(u.perealizadoac).toFixed(2),
									margemacumuladaac: parseFloat(u.margemacumuladaac).toFixed(2),
								};
							})" sort-by="perealizadoac" :sort-desc="true" :items-per-page="28" hide-default-footer class="elevation-0"
                            fixed-header height="70vh">
                <template slot="body.append">
                  <tr class="d-none d-sm-table-row" v-for="(u, i) in dashboard.rankingfooter" :key="i"
                      :class="u.regional == 'Todas' ? 'blue-grey lighten-4' : 'blue lighten-4'">
                    <td width="5%"></td>
                    <td width="22%" class="font-weight-bold text-uppercase text-truncate">{{
                        u.regional == "Todas" ? `Total` : `Regional ${u.regional}` }}</td>
                    <td width="15%" v-if="permissao('dashboard_ranking_vendas_valores')"
                        class="font-weight-bold">{{ u.metaacumuladaac | formataDinheiro }}</td>
                    <td width="18%" v-if="permissao('dashboard_ranking_vendas_valores')"
                        class="font-weight-bold">{{ u.realizadoacumuladoac | formataDinheiro }}</td>
                    <td width="18%" class="text-truncate font-weight-bold">
                      <template v-if="u.perealizadoac">{{ u.perealizadoac.toFixed(2) }}</template>
                      <template v-else>0.00</template>
                    </td>
                    <td width="22%" class="text-truncate font-weight-bold">
                      <template v-if="u.margemacumuladaac">{{ u.margemacumuladaac.toFixed(2)
                        }}</template>
                      <template v-else>0.00</template>
                    </td>
                  </tr>
                </template>

                <template slot="body.append">
                  <v-data-iterator class="d-flex d-sm-none mt-3" :items="dashboard.rankingbody.map((u) => {
										return {
											regional: u.regional,
											metaacumuladaac: u.metaacumuladaac,
											realizadoacumuladoac: u.realizadoacumuladoac,
											perealizadoac: u.perealizadoac,
											margemacumuladaac: u.margemacumuladaac,
										};
									})" disable-filtering disable-pagination disable-sort hide-default-footer>
                    <v-row>
                      <v-flex v-for="(u, i) in dashboard.rankingfooter" :key="i" cols="12"
                              class="px-2 py-0">
                        <v-card
                            :class="u.regional == 'Todas' ? 'blue-grey lighten-3' : 'blue lighten-3'">
                          <v-card-title class="subheading font-weight-bold">{{ u.regional ==
                          "Todas" ? `Total` : `Regional ${u.regional}` }}</v-card-title>
                          <v-divider />
                          <v-list dense
                                  :class="u.regional == 'Todas' ? 'blue-grey lighten-4' : 'blue lighten-4'">
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">META
                                ACUMULADA</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>{{ u.metaacumuladaac |
                                    formataDinheiro }}</v-list-item-content>
                              </div>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">REALIZADO
                                ACUMULADO</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>{{ u.realizadoacumuladoac |
                                    formataDinheiro }}</v-list-item-content>
                              </div>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">REALIZADO
                                (%)</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>
                                  <template v-if="u.perrealizado">{{
                                      u.perealizadoac.toFixed(2) }}</template>
                                  <template v-else>0.00</template>
                                </v-list-item-content>
                              </div>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">MARGEM ACUMULADA
                                (%)</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>
                                  <template v-if="u.margemdiaria">{{
                                      u.margemacumuladaac.toFixed(2) }}</template>
                                  <template v-else>0.00</template>
                                </v-list-item-content>
                              </div>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-flex>
                    </v-row>
                  </v-data-iterator>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
          <v-expansion-panel active-class="primary white--text">
            <v-expansion-panel-header class="text-h6">
              Ranking diário de vendas (projeção)
              <template v-slot:actions>
                <v-icon color="white" class="mr-n6">$expand</v-icon>
                <v-icon>$expand</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-data-table v-if="dashboard.rankingbody" dense :headers="headerProjecao" :items="dashboard.rankingbody.map((u) => {
								const obj = {};
								(obj.rk = u.rk), (obj.filial = u.filial);
								obj.metamensal = parseFloat(u.metamensal).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
								obj.projecaoreal = parseFloat(u.projecaoreal).toLocaleString('pt-br', { style: 'currency', currency: 'BRL' });
								obj.projecaoatingida = `${u.projecaoatingida.toFixed(2)}`;
								obj.vendaanoanterior = parseFloat(u.vendaanoanterior).toLocaleString('pt-br', { style: 'currency', currency: 'BRL', });
								obj.variacao = `${u.variacao.toFixed(2)}`;
								obj.vendamesanterior = parseFloat(u.vendamesanterior).toLocaleString('pt-br', { style: 'currency', currency: 'BRL', });
								obj.variacaomesanterior = `${u.variacaomesanterior.toFixed(2)}`;
								obj.crescimentoorcado = `${u.crescimentoorcado.toFixed(2)}`;
								obj.margemacumuladaac = `${parseFloat(u.margemacumuladaac).toFixed(2)}`;
								return obj;
							})" sort-by="projecaoatingida" :sort-desc="true" :items-per-page="28" hide-default-footer class="elevation-0"
                            fixed-header height="70vh">
                <template slot="body.append">
                  <tr class="d-none d-sm-table-row" mr-5 v-for="(u, i) in dashboard.rankingfooter"
                      :key="i"
                      :class="u.regional == 'Todas' ? 'blue-grey lighten-4' : 'blue lighten-4'">
                    <td></td>
                    <td class="font-weight-bold text-uppercase text-truncate">{{ u.regional ==
                    "Todas" ? `Total` : `Regional ${u.regional}` }}</td>
                    <td v-if="permissao('dashboard_ranking_vendas_valores')" pl-9
                        class="font-weight-bold">{{ u.metamensal | formataDinheiro }}</td>
                    <td v-if="permissao('dashboard_ranking_vendas_valores')"
                        class="font-weight-bold">{{ u.projecaoreal | formataDinheiro }}</td>
                    <td class="text-truncate font-weight-bold">
                      <template v-if="u.projecaoatingida">{{ u.projecaoatingida.toFixed(2)
                        }}</template>
                      <template v-else>0.00</template>
                    </td>
                    <td v-if="permissao('dashboard_ranking_vendas_valores')"
                        class="font-weight-bold">{{
                        u.vendaanoanterior | formataDinheiro }}</td>
                    <td class="text-truncate font-weight-bold">
                      <template v-if="u.variacao">{{ u.variacao.toFixed(2) }}</template>
                      <template v-else>0.00</template>
                    </td>
                    <td v-if="permissao('dashboard_ranking_vendas_valores')"
                        class="font-weight-bold">{{
                        u.vendamesanterior | formataDinheiro }}</td>
                    <td class="text-truncate font-weight-bold">
                      <template v-if="u.variacaomesanterior">{{ u.variacaomesanterior.toFixed(2)
                        }}</template>
                      <template v-else>0.00</template>
                    </td>
                    <td class="text-truncate font-weight-bold">
                      <template v-if="u.crescimentoorcado">{{ u.crescimentoorcado.toFixed(2)
                        }}</template>
                      <template v-else>0.00</template>
                    </td>
                    <td class="text-truncate font-weight-bold">
                      <template v-if="u.margemacumuladaac">{{ u.margemacumuladaac.toFixed(2)
                        }}</template>
                      <template v-else>0.00</template>
                    </td>
                  </tr>
                </template>

                <template slot="body.append">
                  <v-data-iterator class="d-flex d-sm-none mt-3" :items="dashboard.rankingbody.map((u) => {
										return {
											regional: u.regional,
											metamensal: u.metamensal,
											projecaoreal: u.projecaoreal,
											projecaoatingida: u.projecaoatingida,
											vendaanoanterior: u.vendaanoanterior,
											vendamesanterior: u.vendamesanterior,
											variacaomesanterior: u.variacaomesanterior,
											crescimentoorcado: u.crescimentoorcado,
										};
									})" disable-filtering disable-pagination disable-sort hide-default-footer>
                    <v-row>
                      <v-flex v-for="(u, i) in dashboard.rankingfooter" :key="i" cols="12"
                              class="px-2 py-0">
                        <v-card
                            :class="u.regional == 'Todas' ? 'blue-grey lighten-3' : 'blue lighten-3'">
                          <v-card-title class="subheading font-weight-bold">{{ u.regional ==
                          "Todas" ? `Total` : `Regional ${u.regional}` }}</v-card-title>
                          <v-divider />
                          <v-list dense
                                  :class="u.regional == 'Todas' ? 'blue-grey lighten-4' : 'blue lighten-4'">
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">META
                                MENSAL</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>{{ u.metamensal | formataDinheiro
                                  }}</v-list-item-content>
                              </div>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">PROJEÇÃO
                                REAL</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>{{ u.projecaoreal | formataDinheiro
                                  }}</v-list-item-content>
                              </div>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">PROJEÇÃO ATINGIDA
                                (%)</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>
                                  <template v-if="u.projecaoatingida">{{
                                      u.projecaoatingida.toFixed(2) }}</template>
                                  <template v-else>0.00</template>
                                </v-list-item-content>
                              </div>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">{{
                                  `${dashboard.descrmesatual.substr(0,
                                      3)}/${busca.dtdia.split("-")[0] - 1}`
                                }}</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>
                                  <template v-if="u.vendaanoanterior">{{
                                      u.vendaanoanterior | formataDinheiro
                                    }}</template>
                                  <template v-else>0.00</template>
                                </v-list-item-content>
                              </div>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">{{
                                  `${dashboard.mespassado.substr(0,
                                      3)}/${busca.dtdia.split("-")[0]}`
                                }}</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>
                                  <template v-if="u.vendamesanterior">{{
                                      u.vendamesanterior.toFixed(2) }}</template>
                                  <template v-else>0.00</template>
                                </v-list-item-content>
                              </div>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">{{ `VAR.
																${dashboard.mespassado.substr(0,
                                  3)}x${dashboard.descrmesatual.substr(0, 3)} (%)`
                                }}</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>
                                  <template v-if="u.variacaomesanterior">{{
                                      u.variacaomesanterior | formataDinheiro
                                    }}</template>
                                  <template v-else>0.00</template>
                                </v-list-item-content>
                              </div>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">CRESCIMENTO
                                ORÇADO
                                (%)</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>
                                  <template v-if="u.crescimentoorcado">{{
                                      u.crescimentoorcado.toFixed(2) }}</template>
                                  <template v-else>0.00</template>
                                </v-list-item-content>
                              </div>
                            </v-list-item>
                            <v-list-item>
                              <v-list-item-content
                                  class="text-truncate font-weight-bold">MARGEM ACUMULADA
                                (%)</v-list-item-content>
                              <div class="justify-content-end">
                                <v-list-item-content>
                                  <template v-if="u.margemdiaria">{{
                                      u.margemacumuladaac.toFixed(2) }}</template>
                                  <template v-else>0.00</template>
                                </v-list-item-content>
                              </div>
                            </v-list-item>
                          </v-list>
                        </v-card>
                      </v-flex>
                    </v-row>
                  </v-data-iterator>
                </template>
              </v-data-table>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </template>
  </v-row>
</template>

<script>
import { mapState } from "vuex";
import * as XLSX from "xlsx-js-style";
import axios from "axios";
import InputDatePicker from "../Widgets/InputDatePicker";
import GraficoBarDashboard from "../Widgets/GraficoBarDashboard";
import CardDashboard from "../Widgets/CardDashboard";
import MenuInfo from "../Widgets/MenuInfo";
import mixinFilial from "../../util/mixinFilial";
import CampanhaVendaMargem from "./CampanhaVendaMargem";
import CampanhaVendaMargemGerente from "./CampanhaVendaMargemGerente";

export default {
  name: "DashboardRankingVendas",
  mixins: [mixinFilial],
  components: {
    InputDatePicker,
    GraficoBarDashboard,
    CardDashboard,
    MenuInfo,
    CampanhaVendaMargem,
    CampanhaVendaMargemGerente,
  },
  data: () => ({
    // variaveis somente para black friday
    dialogBlackFriday: false,
    mostrarValores: false,
    carregandoBlackFriday: false,
    blackFridayDados: [],
    blackFridayTotais: null,

    // variaveis somente para campanha bonificação e-book
    dialogBonificacaoEbook: false,
    carregandoEbook: false,
    mostrarColunasEbook: false,
    rankingEbook: { lista: [] },
    premiacaoEbook: [1000, 900, 800, 700, 600, 500, 400, 300, 200, 100],
    dialogPedidosEbook: false,
    carregandoPedidosEbook: false,
    pedidosEbook: [],
    vendedorSelecionadoEbook: null,

    filtroFilial: null,
    abaSelecionada: 'filiais',

    dialogVendas: false,
    dialogBonificacoes: false,
    dialogFaturamento: false,
    mostrarColuna: false,
    mostrarColuna1: true,
    mostrarColuna2: true,
    mostrarColuna3: true,
    dialogDados: {},
    headerDiario: [],
    headerAcumulado: [],
    headerProjecao: [],
    diario: [],
    margemmeta: 0,
    margemmetatotal: 0,
    tempoRefresh: 60,
    autoRefresh: false,
    dashboard: { mespassado: " - ", descrmesatual: " - " },
    rankingFat: [],
    rankingBoni: { lista: [], totais: {}},
    rankingBoniAnalitico: { lista: [], totais: {}},
    rankingCampanha: {
      listaFiliais:[],
      listaVendedores:[],
      totais:[],
    },
    panel: [],
    carregando: false,
    carregando2: true,
    busca: {
      dtdia: new Date().toISOString().split("T")[0]
    },
    filiaisVendas:{
      'IVAIPORA': '1',
      'PITANGA': '2',
      'SAO JOAO DO IVAI': '3',
      'CANDIDO DE ABREU': '5',
      'APUCARANA': '7',
      'JARDIM ALEGRE': '8',
      'MANOEL RIBAS': '9',
      'FAXINAL': '10',
      'CAMPO MOURÃO': '11',
      'CIANORTE': '14',
      'PARANAVAI': '15',
      'TELEMACO BORBA': '16',
      'RONCADOR': '17',
      'GUARAPUAVA': '18',
      'PALMITAL': '19',
      'IBIPORA': '20',
      'TURVO': '21',
      'SAO MATEUS DO SUL': '23',
      'SAO JOAO DO TRIUNFO': '24',
      'PONTAL DO PARANA': '26',
      'MANDAGUARI': '27',
      'CAMBE': '30',
      'RESERVA': '31',
      'ROLANDIA': '35',
      'MARINGA': '36',
      'LARANJEIRAS DO SUL': '38',
      'CASTELO': '41',
      'FRANCISCO BELTRÃO': '45',
    },
  }),
  computed: {
    ...mapState(["backendUrl", "usuario"]),

    filiaisFiltro() {
      if (this.filiais.lista) {
        return this.filiais.lista.filter((v) => {
          return (
              v.idfilial != 6 &&
              v.idfilial != 4 &&
              v.idfilial != 12 &&
              v.idfilial != 13 &&
              v.idfilial != 25 &&
              v.idfilial != 28 &&
              v.idfilial != 29 &&
              v.idfilial != 32 &&
              v.idfilial != 33 &&
              v.idfilial != 40 &&
              v.idfilial != 42 &&
              v.idfilial != 43 &&
              v.idfilial != 39 &&
              v.idfilial != 37
          );
        });
      } else {
        return [];
      }
    },

    listaFiltradaComMeta() {
      return this.rankingBoniAnalitico.lista?.filter(v => v.meta > 0) || [];
      // return this.rankingBoniAnalitico.lista || [];
    },

    totaisRankingEbook() {
      return (this.rankingEbook.lista || []).reduce((acc, item) => {
        acc.totalPontos += item.total_pontos || 0;
        acc.totalPremiacao += this.premiacaoEbook[item.posicao - 1] || 0;
        acc.totalVendas += item.total_vendas || 0;
        acc.totalQtdEbook += item.total_qtd_ebook || 0;
        acc.totalValorEbook += item.total_valor_ebook || 0;
        return acc;
      }, { totalPontos: 0, totalPremiacao: 0, totalVendas: 0, totalQtdEbook: 0, totalValorEbook: 0 });
    },

    totaisPedidosEbook() {
      return (this.pedidosEbook || []).reduce((acc, pedido) => {
        acc.totalValorLiquido += pedido.valtotliquido || 0;
        acc.totalQtdEbook += pedido.qtdproduto_ebook || 0;
        acc.totalValorEbook += pedido.valtotliquido_ebook || 0;
        acc.totalPontos += pedido.pontos || 0;
        return acc;
      }, { totalValorLiquido: 0, totalQtdEbook: 0, totalValorEbook: 0, totalPontos: 0 });
    },

  },
  methods: {
    getRankingColor(position) {
      if (position === 1) return 'yellow darken-2'; // Ouro
      if (position === 2) return 'grey darken-1'; // Prata
      if (position === 3) return 'orange darken-2'; // Bronze
      return 'grey lighten-1';
    },

    premiacaoEbookDoItem(item) {
      const premio = this.premiacaoEbook[item.posicao - 1];
      return premio ? this.formatarMoeda(premio) : '-';
    },

    corPosicaoExcel(posicao) {
      if (posicao === 1) return 'FFFFD966'; // ouro
      if (posicao === 2) return 'FFBFBFBF'; // prata
      if (posicao === 3) return 'FFC55A11'; // bronze
      return 'FFFFF8E1'; // creme (padrão das demais linhas)
    },

    exportarRankingEbookExcel() {
      const top15 = (this.rankingEbook.lista || []).slice(0, 15);
      if (!top15.length) return;

      const CREME = 'FFFFF8E1';
      const NAVY = 'FF002060';
      const SEM_PREMIACAO = 'FFE0E0E0'; // cinza — vendedores fora da faixa premiada

      const cabecalho = ['RK', 'VENDEDOR', 'FILIAL', 'PONTOS', 'PREMIAÇÃO'];
      const linhas = top15.map((item) => [
        item.posicao,
        item.vendedor,
        item.empresa,
        item.total_pontos || 0,
        this.premiacaoEbook[item.posicao - 1] || 0,
      ]);

      const worksheet = XLSX.utils.aoa_to_sheet([cabecalho, ...linhas]);

      const bordaFina = {
        top: { style: 'thin', color: { rgb: 'FF000000' } },
        bottom: { style: 'thin', color: { rgb: 'FF000000' } },
        left: { style: 'thin', color: { rgb: 'FF000000' } },
        right: { style: 'thin', color: { rgb: 'FF000000' } },
      };

      const range = XLSX.utils.decode_range(worksheet['!ref']);
      for (let linha = range.s.r; linha <= range.e.r; linha++) {
        for (let coluna = range.s.c; coluna <= range.e.c; coluna++) {
          const endereco = XLSX.utils.encode_cell({ r: linha, c: coluna });
          const celula = worksheet[endereco];
          if (!celula) continue;

          if (linha === 0) {
            celula.s = {
              font: { bold: true, color: { rgb: 'FFFFFFFF' } },
              fill: { fgColor: { rgb: NAVY } },
              alignment: { horizontal: 'center', vertical: 'center' },
              border: bordaFina,
            };
            continue;
          }

          const item = top15[linha - 1];
          const isPosicao = coluna === 0;
          const isPontos = coluna === 3;
          const premiado = item.posicao <= this.premiacaoEbook.length;

          let corFundo = CREME;
          if (!premiado) {
            corFundo = SEM_PREMIACAO;
          } else if (isPosicao) {
            corFundo = this.corPosicaoExcel(item.posicao);
          }

          celula.s = {
            font: isPontos
                ? { bold: true, underline: true, color: { rgb: 'FF023449' } }
                : { bold: isPosicao, color: { rgb: premiado ? 'FF000000' : 'FF757575' } },
            fill: { fgColor: { rgb: corFundo } },
            alignment: {
              horizontal: coluna === 1 || coluna === 2 ? 'left' : 'center',
              vertical: 'center',
            },
            border: bordaFina,
          };

          if (isPosicao) celula.z = '0"º"';
          if (coluna === 4) celula.z = '"R$" #,##0.00';
        }
      }

      worksheet['!cols'] = [
        { wch: 5 },  // RK
        { wch: 35 }, // Vendedor
        { wch: 22 }, // Filial
        { wch: 10 }, // Pontos
        { wch: 14 }, // Premiação
      ];
      worksheet['!rows'] = [{ hpt: 21 }];

      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Ranking');

      const dataSelecionada = new Date(`${this.busca.dtdia || this.getDataAtual()}T00:00:00`);
      const mes = dataSelecionada.toLocaleDateString('pt-BR', { month: 'long' });
      const mesFormatado = mes.charAt(0).toUpperCase() + mes.slice(1);

      XLSX.writeFile(workbook, `Premiação Ebook - ${mesFormatado}.xlsx`);
    },

    // funções somente para black friday
    listaBlackFriday() {
      this.carregandoBlackFriday = true;
      return axios
          .post(`${this.backendUrl}dashboard/blackfriday`, {})
          .then((res) => {
            // Ordena por atingimento total (maior para menor)
            this.blackFridayDados = res.data
                .sort((a, b) => b.atingimento_total - a.atingimento_total);

            // Calcula os totais
            this.blackFridayTotais = this.calcularTotaisBlackFriday(res.data);

            this.carregandoBlackFriday = false;
          })
          .catch(() => {
            this.carregandoBlackFriday = false;
          });
    },

    calcularTotaisBlackFriday(dados) {
      const totais = dados.reduce((acc, item) => {
        acc.venda_sexta += item.venda_sexta || 0;
        acc.meta_sexta += item.meta_sexta || 0;
        acc.venda_sabado += item.venda_sabado || 0;
        acc.meta_sabado += item.meta_sabado || 0;
        acc.venda_total += item.venda_total || 0;
        acc.meta_total += item.meta_total || 0;
        acc.lucro_sexta += (item.venda_sexta * item.margem_sexta / 100) || 0;
        acc.lucro_sabado += (item.venda_sabado * item.margem_sabado / 100) || 0;
        return acc;
      }, {
        venda_sexta: 0,
        meta_sexta: 0,
        venda_sabado: 0,
        meta_sabado: 0,
        venda_total: 0,
        meta_total: 0,
        lucro_sexta: 0,
        lucro_sabado: 0,
      });

      return {
        venda_sexta: totais.venda_sexta,
        meta_sexta: totais.meta_sexta,
        atingimento_sexta: totais.meta_sexta > 0
            ? (totais.venda_sexta / totais.meta_sexta) * 100
            : 0,
        margem_sexta: totais.venda_sexta > 0
            ? (totais.lucro_sexta / totais.venda_sexta) * 100
            : 0,
        venda_sabado: totais.venda_sabado,
        meta_sabado: totais.meta_sabado,
        atingimento_sabado: totais.meta_sabado > 0
            ? (totais.venda_sabado / totais.meta_sabado) * 100
            : 0,
        margem_sabado: totais.venda_sabado > 0
            ? (totais.lucro_sabado / totais.venda_sabado) * 100
            : 0,
        venda_total: totais.venda_total,
        meta_total: totais.meta_total,
        atingimento_total: totais.meta_total > 0
            ? (totais.venda_total / totais.meta_total) * 100
            : 0,
      };
    },

    atingimentoCor(valor) {
      if (valor === 0) return '';
      if (valor >= 100) return 'green--text text--darken-2';
      if (valor >= 90) return 'light-green--text text--darken-2';
      if (valor >= 80) return 'orange--text text--darken-2';
      return 'red--text text--darken-2';
    },

    abrirDialogBlackFriday() {
      this.blackFridayDados = [];
      this.dialogBlackFriday = true;
      this.listaBlackFriday();
    },
    // ------------------

    // funções somente para campanha bonificação e-book
    listaRankingEbook() {
      this.carregandoEbook = true;
      return axios
          .post(`${this.backendUrl}bonificacao/ebook/vendedor/analitico/listar`, { data: this.busca.dtdia })
          .then((res) => {
            this.rankingEbook.lista = res.data || [];
            this.carregandoEbook = false;
          })
          .catch(() => {
            this.rankingEbook.lista = [];
            this.carregandoEbook = false;
          });
    },

    abrirPedidosEbook(item) {
      this.vendedorSelecionadoEbook = item;
      this.pedidosEbook = [];
      this.dialogPedidosEbook = true;
      this.carregandoPedidosEbook = true;
      axios
          .post(`${this.backendUrl}bonificacao/ebook/vendedor/pedidos/listar`, { idvendedor: item.idvendedor, data: this.busca.dtdia })
          .then((res) => {
            this.pedidosEbook = res.data || [];
            this.carregandoPedidosEbook = false;
          })
          .catch(() => {
            this.pedidosEbook = [];
            this.carregandoPedidosEbook = false;
          });
    },

    getDataAtual() {
      const hoje = new Date();

      const ano = hoje.getFullYear();
      const mes = String(hoje.getMonth() + 1).padStart(2, '0');
      const dia = String(hoje.getDate()).padStart(2, '0');

      return `${ano}-${mes}-${dia}`;
    },

    dataCampanha(hoje) {

      // datas definidas para campanha Queima de Estoque (Dinheiro e PIX) idpromocao = 7829
      let dataInicio = '2025-10-02'
      let dataFim = '2025-12-31'

      return hoje >= dataInicio && hoje <= dataFim
    },
    formataDataFiltro(dateStr) {
      const [year, month] = dateStr.split("-");
      return `${month}/${year}`;
    },
    isMesEAnoAtual(dataString) {
      if (!dataString) return false;

      const [ano, mes] = dataString.split('-');
      return ano === '2025' && mes === '06';
    },

    isPrimeiroDiaUtil(dateString) {
      const [ano, mes, dia] = dateString.split('-').map(Number);
      const d = new Date(ano, mes - 1, dia);

      const primeiroDia = new Date(ano, mes - 1, 1);

      while (primeiroDia.getDay() === 0 || primeiroDia.getDay() === 6) {
        primeiroDia.setDate(primeiroDia.getDate() + 1);
      }

      return (
          d.getFullYear() === primeiroDia.getFullYear() &&
          d.getMonth() === primeiroDia.getMonth() &&
          d.getDate() === primeiroDia.getDate()
      );
    },
    formatarVariacao(valor) {
      // const dataFiltro = this.busca.dtdia;

      // if (this.isPrimeiroDiaUtil(dataFiltro)) {
      //   return '-';
      // } else {
      return `${valor.toFixed(2)} %`;
      // }
    },

    margemCorBoni(margem, margemmeta) {
      if (margem < margemmeta) {
        return "red--text text--darken-1";
      } else {
        return "blue--text text--darken-1";
      }

    },


    projecaoCor(valor) {
      if (valor >= 110) return 'blue--text text--darken-1';
      if (valor >= 100) return 'green--text text--darken-1';
      if (valor >= 90) return 'orange--text text--darken-1';
      return 'red--text text--darken-1';
    },

    bonificacaoCor(valor) {
      if (valor > 0) return 'green--text';
      return 'red--text';
    },

    perBonificacaoCor(valor) {
      if (valor >= 100) return 'blue--text text--darken-1';
      if (valor >= 90) return 'orange--text text--darken-1';
      return 'red--text text--darken-1';
    },

    get() {
      this.dashboard = { mespassado: " - ", descrmesatual: " - " };
      this.carregando = true;
      return axios
          .post(`${this.backendUrl}dashboard/ranking`, {
            data: this.busca.dtdia,
          })
          .then((res) => {
            this.dashboard = res.data;
            let cont = 1;
            this.dashboard.rankingbody.forEach((v) => {
              v.rk = cont;
              cont++;
            });
            this.carregando = false;
            this.dialogDados = this.dashboard.rankingbody
                .sort((a, b) => b.perealizadoac - a.perealizadoac)
                .map((v) => {
                  return {
                    filial: v.filial,
                    perrealizado: v.perrealizado,
                    perealizadoac: v.perealizadoac,
                    perrealiadodiarioac: v.perrealizado_new, //v.permetadiariaacumulada,
                    metadia_new: v.metadia_new,
                    margemdiaria: v.margemdiaria,
                    margemacumuladaac: v.margemacumuladaac,
                    realizadodia: v.realizadodia,
                    realizadoacumuladoac: v.realizadoacumuladoac,
                    projecaoreal: v.projecaoreal,
                    projecaoatingida: v.projecaoatingida,
                    variacao: v.variacao,
                    vendaacumuladaaa: v.vendaac_aa,
                    variacaoprojecaoaa: v.variacao_cres_proj_aa,
                  };
                });
            this.diario = this.dashboard.rankingbody
                .sort((a, b) => b.perrealizado - a.perrealizado)
                .map((u, i) => {
                  return {
                    rk: i + 1,
                    filial: u.filial,
                    metadia: parseFloat(u.metadia).toLocaleString(
                        "pt-br",
                        {
                          style: "currency",
                          currency: "BRL",
                        }
                    ),
                    realizadodia: parseFloat(
                        u.realizadodia
                    ).toLocaleString("pt-br", {
                      style: "currency",
                      currency: "BRL",
                    }),
                    perrealizado: parseFloat(
                        u.perrealizado
                    ).toFixed(2),
                    margemdiaria: parseFloat(
                        u.margemdiaria
                    ).toFixed(2),
                  };
                });
            if (this.autoRefresh) {
              this.tempoRefresh = 60;
              setTimeout(() => {
                this.get();
              }, 60000);
            }
            this.montaHeaderDiario();
            this.montaHeaderAcumulado();
            this.montaHeaderProjecao();
            // this.montaHeaderGrupoGerencial();
          })
          .catch(() => {
            this.carregando = false;
          });
    },
    listaIndicesFat(){
      this.carregando = true;
      return axios
          .post(`${this.backendUrl}dashboard/ranking/faturamento/dre/listar`, {
            data: this.busca.dtdia,
          })
          .then((res) => {
            this.rankingFat = res.data;
            this.carregando = false;
          })
          .catch(() => {
            this.carregando = false;
          });
    },
    listaBonificacoes(){
      this.carregando2 = false;
      return axios
          .post(`${this.backendUrl}bonificacao/gerente/listar`, {
            data: this.busca.dtdia,
          })
          .then((res) => {
            // this.rankingBoni.lista = res.data.lista
            this.rankingBoni.totais = res.data.totais;
            this.rankingBoni.lista = res.data.lista
                .map((v) => {
                  const perbonificacao = (((Math.min(v.margem, v.margemmeta) / v.margemmeta) + (Math.min(v.atingimentoac, 100) / 100)) / 2 * 100).toFixed(2);
                  return {
                    ...v,
                    perbonificacao: perbonificacao, // mantém como número
                  };
                })
                .sort((a, b) => b.perbonificacao - a.perbonificacao); // ordena do maior para o menor

            this.carregando2 = false;
          })
          .catch(() => {
            this.carregando2 = false;
          });
    },
    listaBonificacoesCampanha(){
      this.carregando = true;
      this.rankingCampanha.listaFiliais = [];
      this.rankingCampanha.listaVendedores = [];
      this.rankingCampanha.totais = [];
      return axios
          .post(`${this.backendUrl}bonificacao/campanha/listar`, {
            data: this.busca.dtdia,
            idempresa: this.permissao('dashboard_ranking_filtro_filiais_bonificacoes') ? (this.filtroFilial ? this.filtroFilial.toString() : this.filiaisFiltro.map(item => item.idfilial).join(',')) : this.usuario.idfilial.toString(),
          })
          .then((res) => {
            let dados = res.data;
            this.rankingCampanha.listaFiliais = dados.listafiliais;
            this.rankingCampanha.listaVendedores = dados.listavendedores;
            this.rankingCampanha.totais = dados.totais;
            this.carregando = false;
          })
          .catch(() => {
            this.carregando = false;
          });
    },
    listaVendedoresBonificacoes(){
      this.carregando2 = true;
      this.rankingBoniAnalitico = { lista: [], totais: {}};
      return axios
          .post(`${this.backendUrl}bonificacao/vendedor/analitico/listar`, {
            data: this.busca.dtdia,
            idempresa: this.permissao('dashboard_ranking_filtro_filiais_bonificacoes') ? (this.filtroFilial ? this.filtroFilial.toString() : this.filiaisFiltro.map(item => item.idfilial).join(',')) : this.usuario.idfilial.toString(),
          })
          .then((res) => {
            this.rankingBoniAnalitico.totais = res.data.totais;
            this.rankingBoniAnalitico.lista = res.data.lista
                .map((v) => {
                  const perbonificacao = (((Math.min(v.margemac, 24) / 24) + (Math.min(v.perprojecao, 100) / 100)) / 2 * 100).toFixed(2);
                  return {
                    ...v,
                    perbonificacao: perbonificacao, // mantém como número
                  };
                })
                .sort((a, b) => b.perbonificacao - a.perbonificacao); // ordena do maior para o menor

            this.carregando2 = false;
          })
          .catch(() => {
            this.carregando2 = false;
          });
    },
    listaMargeMeta(){
      this.margemmeta = 0;
      this.margemmetatotal = 0;
      this.carregando = true;
      let dataFiltro = this.formataDataFiltro(this.busca.dtdia)
      return axios.post(`${this.backendUrl}dashboard/onepage/margemmeta`, {
        periodo: dataFiltro,
      })
          .then((res) => {
            let data = res.data.margemmeta;

            if (typeof data === "string") {
              try {
                data = JSON.parse(data);
              } catch (e) {
                console.error("Erro ao parsear margemmeta:", e);
              }
            }

            this.margemmeta = data;
            this.margemmetatotal = this.margemmeta["TOTAL"];

            ["4", "28", "39", "42", "43", "TOTAL"].forEach(k => delete this.margemmeta[k]);
            this.carregando = false;
          })
          .catch(() => {
            this.carregando = false;
          });
    },
    timerRefresh() {
      if (this.tempoRefresh < 0) {
        this.tempoRefresh = 60;
      }
      setTimeout(() => {
        this.tempoRefresh--;
        this.timerRefresh();
      }, 1000);
    },
    async init() {
      if (new Date(this.busca.dtdia).getDay() == 6) {
        this.busca.dtdia = `${new Date(new Date().setHours(-25))
            .toLocaleDateString("pt-BR")
            .split("/")
            .reverse()
            .join("-")}`;
      } else {
        await this.get();
        this.listaIndicesFat();
        this.listaBonificacoes();
        // filiaisFiltro() depende de filiais.lista (carregada pelo mixinFilial em created(), sem await) — se
        // ainda não chegou nesse ponto, espera aqui, senão listaVendedoresBonificacoes()/listaBonificacoesCampanha()
        // montam idempresa como "" (bug: [].map(...).join(',') === "")
        if (!this.filiais.lista) {
          await this.listarEmpresas();
        }
        this.listaVendedoresBonificacoes();
        this.listaMargeMeta();
        this.listaBonificacoesCampanha();
        this.listaRankingEbook();
      }
      this.timerRefresh();
    },
    montaHeaderDiario() {
      if (this.permissao("dashboard_ranking_vendas_valores")) {
        this.headerDiario = [
          { text: "RK", value: "rk", sortable: false },
          { text: "FILIAL", value: "filial", sortable: false },
          { text: "META DIÁRIA", value: "metadia", sortable: false },
          {
            text: "REALIZADO DIÁRIO",
            value: "realizadodia",
            sortable: false,
          },
          { text: "REALIZADO (%)", value: "perrealizado" },
          {
            text: "MARGEM DIÁRIA (%)",
            value: "margemdiaria",
            sortable: false,
          },
        ];
      } else {
        this.headerDiario = [
          { text: "RK", value: "rk", sortable: false },
          { text: "FILIAL", value: "filial", sortable: false },
          { text: "REALIZADO (%)", value: "perrealizado" },
          {
            text: "MARGEM DIÁRIA (%)",
            value: "margemdiaria",
            sortable: false,
          },
        ];
      }
    },
    montaHeaderAcumulado() {
      if (this.permissao("dashboard_ranking_vendas_valores")) {
        this.headerAcumulado = [
          { text: "RK", value: "rk", sortable: false },
          { text: "FILIAL", value: "filial", sortable: false },
          {
            text: "META ACUMULADA",
            value: "metaacumuladaac",
            sortable: false,
          },
          {
            text: "REALIZADO ACUMULADO",
            value: "realizadoacumuladoac",
            sortable: false,
          },
          { text: "REALIZADO (%)", value: "perealizadoac" },
          {
            text: "MARGEM ACUMULADA (%)",
            value: "margemacumuladaac",
            sortable: false,
          },
        ];
      } else {
        this.headerAcumulado = [
          { text: "RK", value: "rk", sortable: false },
          { text: "FILIAL", value: "filial", sortable: false },
          { text: "REALIZADO (%)", value: "perealizadoac" },
          {
            text: "MARGEM ACUMULADA (%)",
            value: "margemacumuladaac",
            sortable: false,
          },
        ];
      }
    },
    montaHeaderProjecao() {
      if (this.permissao("dashboard_ranking_vendas_valores")) {
        this.headerProjecao = [
          { text: "RK", value: "rk", sortable: false },
          { text: "FILIAL", value: "filial", sortable: false },
          {
            text: "META MENSAL",
            value: "metamensal",
            sortable: false,
          },
          {
            text: "PROJEÇÃO REAL",
            value: "projecaoreal",
            sortable: false,
          },
          {
            text: "PROJEÇÃO ATINGIDA (%)",
            value: "projecaoatingida",
          },
          {
            text: `${this.dashboard.descrmesatual.substr(0, 3)}/${this.busca.dtdia.split("-")[0] - 1
            }`,
            value: "vendaanoanterior",
            sortable: false,
          },
          {
            text: "VAR. REAL (%)",
            value: "variacao",
            sortable: false,
          },
          {
            text: `${this.dashboard.mespassado.substr(0, 3)}/${this.busca.dtdia.split("-")[0]
            }`,
            value: "vendamesanterior",
            sortable: false,
          },
          {
            text: `VAR. ${this.dashboard.mespassado.substr(
                0,
                3
            )}x${this.dashboard.descrmesatual.substr(0, 3)} (%)`,
            value: "variacaomesanterior",
            sortable: false,
          },
          {
            text: "CRESCIMENTO ORÇADO (%)",
            value: "crescimentoorcado",
            sortable: false,
          },
          {
            text: "MARGEM ACUMULADA (%)",
            value: "margemacumuladaac",
            sortable: false,
          },
        ];
      } else {
        this.headerProjecao = [
          { text: "RK", value: "rk", sortable: false },
          { text: "FILIAL", value: "filial", sortable: false },
          {
            text: "PROJEÇÃO ATINGIDA (%)",
            value: "projecaoatingida",
          },
          {
            text: "VAR. REAL (%)",
            value: "variacao",
            sortable: false,
          },
          {
            text: `VAR. ${this.dashboard.mespassado.substr(
                0,
                3
            )}x${this.dashboard.descrmesatual.substr(0, 3)} (%)`,
            value: "variacaomesanterior",
            sortable: false,
          },
          {
            text: "CRESCIMENTO ORÇADO (%)",
            value: "crescimentoorcado",
            sortable: false,
          },
        ];
      }
    },
    margemCor(valor) {
      if (valor === 0) return '';
      if (valor <= 24.50) {
        return "red--text text--darken-2";
      } else if (valor >= 24.51 && valor <= 25.99) {
        return "green--text text--darken-2";
      } else {
        return "blue--text text--darken-2";
      }
    },
    margemCorFilial(margem, margemmeta){
      if (margem <= margemmeta) {
        return "red--text text--darken-2";
      } else {
        return "blue--text text--darken-2";
      }
    },
    variacaoCor(valor) {
      if (valor < 0) {
        return "red--text text--darken-2";
      } else if (valor > 0) {
        return "blue--text text--darken-2";
      } else {
        return "black--text";
      }
    },
    realizadoCor(valor) {
      if (valor >= 100) {
        return "blue--text text--darken-2";
      }
    },
    corMod1(array, campo) {
      let cores = [];
      cores = array.map((v) => {
        let cor;
        cor = this.corSemafaro(v[campo]);
        return this.shadeColor(cor, 100 - v[campo] / 3);
      });
      return cores;
    },
    corMod2(array, campo) {
      let cores = [];
      cores = array.map((v) => {
        let cor = "#002D56";
        return this.shadeColor(cor, 100 - v[campo] / 3);
      });
      return cores;
    },
    corSemafaro(valor) {
      let cor;
      if (valor >= 90) cor = "#002D56";
      if (valor < 90) cor = "#F2B90F";
      if (valor < 70) cor = "#951015";
      return cor;
    },
    shadeColor(color, percent) {
      var R = parseInt(color.substring(1, 3), 16);
      var G = parseInt(color.substring(3, 5), 16);
      var B = parseInt(color.substring(5, 7), 16);
      R = parseInt((R * (100 + percent)) / 100);
      G = parseInt((G * (100 + percent)) / 100);
      B = parseInt((B * (100 + percent)) / 100);
      R = R < 255 ? R : 255;
      G = G < 255 ? G : 255;
      B = B < 255 ? B : 255;
      var RR =
          R.toString(16).length == 1
              ? "0" + R.toString(16)
              : R.toString(16);
      var GG =
          G.toString(16).length == 1
              ? "0" + G.toString(16)
              : G.toString(16);
      var BB =
          B.toString(16).length == 1
              ? "0" + B.toString(16)
              : B.toString(16);
      return "#" + RR + GG + BB;
    },
  },
  watch: {
    "busca.dtdia"() {
      this.get();
      this.listaMargeMeta();
      this.listaIndicesFat();
      this.listaBonificacoes();
      this.listaVendedoresBonificacoes();
      this.listaBonificacoesCampanha();
      this.listaRankingEbook();
    },
    autoRefresh: function () {
      if (this.autoRefresh) {
        this.tempoRefresh = 60;
        this.get();
        this.listaIndicesFat();
        this.listaBonificacoes();
        this.listaVendedoresBonificacoes();
        this.listaMargeMeta();
        this.listaBonificacoesCampanha();
      }
    },
  },
  created() {
    this.init();
  },
};
</script>

<style>
.v-dialog {
  max-height: 97% !important;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

.font-size-table td {
  font-size: 1.1em !important;
}

.loading-container {
  display: flex;
  justify-content: center; /* Centraliza horizontalmente */
  align-items: center;     /* Centraliza verticalmente */
  height: 100vh;           /* Ocupa toda a altura da tela */
  width: 100vw;            /* Ocupa toda a largura da tela */
  position: fixed;         /* Fixa na tela */
  top: 0;
  left: 0;
}

.fulfilling-square-spinner, .fulfilling-square-spinner * {
  box-sizing: border-box;
}

.fulfilling-square-spinner {
  height: 100px;
  width: 100px;
  position: relative;
  border: 4px solid #C62828;
  animation: fulfilling-square-spinner-animation 4s infinite ease;
}

.fulfilling-square-spinner .spinner-inner {
  vertical-align: top;
  display: inline-block;
  background-color: #C62828;
  width: 100%;
  opacity: 1;
  animation: fulfilling-square-spinner-inner-animation 4s infinite ease-in;
}

/* animações */
@keyframes fulfilling-square-spinner-animation {
  0%, 50% { transform: rotate(0deg); }
  25%, 75% { transform: rotate(180deg); }
  100% { transform: rotate(360deg); }
}

@keyframes fulfilling-square-spinner-inner-animation {
  0%, 25% { height: 0%; }
  50%, 75% { height: 100%; }
  100% { height: 0%; }
}

</style>

